// Persian translations
import type { TranslationKeys } from './en';

export const fa: TranslationKeys = {
  common: {
    loading: "در حال بارگذاری...",
    error: "مشکلی پیش آمد",
    retry: "تلاش مجدد",
    save: "ذخیره",
    cancel: "انصراف",
    confirm: "تأیید",
    back: "بازگشت",
    next: "بعدی",
    submit: "ارسال",
    close: "بستن",
    recommended: "پیشنهادی",
    included: "شامل",
    comingSoon: "به زودی",
    drawing: "نقاشی",
    photo: "عکس",
    style: "سبک",
    size: "اندازه",
    material: "متریال",
    color: "رنگ",
    redo: "تکرار",
    free: "رایگان",
    toy: "اسباب‌بازی",
    character: "شخصیت",
    confirmed: "تأیید شده",
    complete: "تکمیل",
    leave: "خروج",
    stay: "ادامه",
    loadingMagic: "جادو در راه است...",
    userMenu: "منوی کاربر",
    openMenu: "باز کردن منو",
    goBack: "بازگشت",
    processing: "در حال پردازش...",
    addAnotherImage: "افزودن تصویر دیگر",
    familiesCreated: "خانواده اسباب‌بازی ساختند",
    untitled: "بدون عنوان",
    untitledStory: "داستان بدون عنوان",
    untitledAnimation: "انیمیشن بدون عنوان",
    fromPrefix: "از ",
    rial: "ریال",
    themeLight: "رفتن به حالت روشن",
    themeDark: "رفتن به حالت تاریک",
    generatingCharacter: "در حال ساخت کاراکتر شما...",
    buildingModel: "در حال ساخت مدل سه‌بعدی...",
    wizardSteps: "مراحل ویزارد",
    pageNavigation: "ناوبری صفحه",
    cover: "جلد",
    backCover: "جلد پشت",
    original: "اصلی",
    after: "بعد",
    before: "قبل",
  },

  orderDiscount: {
    label: "کد تخفیف",
    placeholder: "کد",
    apply: "اعمال",
    applying: "در حال بررسی…",
    clear: "حذف",
    applied: "{percent}٪ تخفیف",
    invalid: "این کد قابل استفاده نیست.",
    limit: "سقف استفادهٔ این کد پر شده است.",
  },

  credits: {
    insufficientTitle: "اعتبار کافی نیست",
    insufficientBody: "برای ادامه، اعتبار بیشتری بخرید.",
    insufficientAction: "خرید اعتبار",
    balance: {
      chip: "{n} اعتبار",
    },
    buy: {
      title: "خرید اعتبار",
      subtitle: "یک بسته را برای شارژ حساب خود انتخاب کنید.",
      cta: "خرید",
      pending: "در حال پردازش…",
      empty: "در حال حاضر بسته‌ای موجود نیست.",
      error: "خرید ناموفق بود. لطفاً دوباره تلاش کنید.",
      success: {
        title: "اعتبار اضافه شد!",
        body: "{n} اعتبار به حساب شما اضافه شد.",
      },
      code: {
        title: "کد شارژ",
        hint: "اگر کد شارژ دارید، آن را وارد کنید.",
        placeholder: "مثلاً SUMMER-26",
        cta: "اعمال کد",
        pending: "در حال اعمال…",
        successTitle: "کیف پول شارژ شد",
        successBody: "{n} اعتبار به کیف پول شما اضافه شد.",
        invalid: "این کد معتبر نیست یا برای حساب شما نیست.",
        limit: "سقف استفاده از این کد پر شده است.",
      },
    },
  },

  subscription: {
    currentPlan: "پلن فعلی",
    subscribeCta: "اشتراک",
    subscribing: "در حال انتقال به درگاه…",
    returning: "در حال بازگشت از پرداخت…",
    success: {
      title: "اشتراک شما فعال شد!",
      body: "شما اکنون مشترک پلن {plan} هستید.",
    },
    error: "ثبت اشتراک ناموفق بود. لطفاً دوباره تلاش کنید.",
    account: {
      title: "اشتراک",
      monthlyCredits: "{n} اعتبار در ماه",
      nextGrant: "پایان دوره فعلی: {date}",
      noSubscription: "اشتراک فعالی ندارید.",
      browsePlans: "مشاهده پلن‌ها",
      cancelCta: "لغو اشتراک",
      cancelling: "در حال لغو…",
      cancelled: "لغو شده",
      cancelSuccess: "اشتراک در پایان این دوره قطع می‌شود.",
      cancelError: "لغو ناموفق بود. لطفاً دوباره تلاش کنید.",
      pastDue: "نیاز به تمدید",
      renewCta: "تمدید",
      renewHint: "برای دریافت اعتبار این ماه دوباره پرداخت کنید.",
      resumeCta: "ادامه اشتراک",
      resumeSuccess: "لغو برنامه‌ریزی‌شده برداشته شد.",
      resumeError: "ادامه اشتراک ناموفق بود. لطفاً دوباره تلاش کنید.",
      cancelsOn: "تا {date} فعال است",
    },
  },



  header: {
    nav: {
      home: "خانه",
      gallery: "گالری",
      howItWorks: "چگونه کار می‌کند",
      pricing: "قیمت‌ها",
      about: "درباره ما",
      reviews: "نظرات",
      startCreating: "شروع ساخت",
      signIn: "ورود",
      signOut: "خروج",
      account: "حساب کاربری",
      create: "بساز",
      orders: "سفارش‌ها",
    },
    brand: "روبی",
    followOn: "روبی را در {name} دنبال کنید",
    mobileTagline: "بیایید چیزی جادویی بسازیم",
    switchTo: "تغییر به {name}",
  },

  landing: {
    hero: {
      headline: "هنر کودکتان را به یادگاری ماندگار تبدیل کنید",
      subheadline: "یک نقاشی یا عکس آپلود کنید. در چند ثانیه پیش‌نمایش سه‌بعدی ببینید. ما می‌سازیم و ارسال می‌کنیم.",
      tagline: "هنرشان. واقعی شده.",
      cta: "نقاشی آپلود کنید — پیش‌نمایش رایگان",
      ctaSubtext: "بدون نیاز به حساب کاربری · ۳۰ ثانیه · جادو را ببینید",
      trust: {
        safety: "مواد ایمن برای کودکان",
        shipping: "ارسال به سراسر جهان",
        preview: "پیش‌نمایش قبل از پرداخت",
        guarantee: "تضمین ۱۰۰٪ رضایت",
      },
      showcase: {
        title: "جادو را در عمل ببینید",
        pair1: "نقاشی به اسباب‌بازی کارتونی",
        pair2: "نقاشی به اسباب‌بازی واقعی",
        pair3: "عکس به فیگور سه‌بعدی",
        pair4: "عکس به سبک فانکو",
      },
      tabs: {
        drawings: "از نقاشی",
        photos: "از عکس",
        storybooks: "کتاب داستان",
        drawingsDesc: "هر نقاشی کودک را آپلود کنید و تبدیل آن به اسباب‌بازی سه‌بعدی سفارشی را تماشا کنید.",
        photosDesc: "عکس حیوانات خانگی، افراد یا شخصیت‌ها را به فیگورهای کلکسیونی خیره‌کننده تبدیل کنید.",
        storybooksDesc: "نقاشی کودکتان را به کتاب داستان مصور جادویی با روایت هوش مصنوعی تبدیل کنید.",
        drawingsCta: "با نقاشی امتحان کنید",
        photosCta: "با عکس امتحان کنید",
        storybooksCta: "ساخت کتاب داستان",
      },
    },
    gallery: {
      title: "هنر واقعی. اسباب‌بازی واقعی. خانواده‌های واقعی.",
      subtitle: "هر یادگاری از یک نقاشی روی یخچال شروع شد",
      tabs: {
        drawings: "نقاشی → اسباب‌بازی",
        photos: "عکس → فیگور",
        storybooks: "نقاشی → کتاب داستان",
      },
      seeFullGallery: "مشاهده گالری کامل",
      cta: "بسازید — نقاشی آپلود کنید",
      styles: {
        cartoon: "سبک کارتونی",
        cartoonDesc: "ببینید چگونه خط‌خطی‌ها به شخصیت‌های پرانرژی و رنگارنگ تبدیل می‌شوند!",
        realistic: "سبک واقع‌گرایانه",
        realisticDesc: "رویاهای مدادرنگی را به فیگورهای موزه‌ای با جزئیات خیره‌کننده تبدیل کنید.",
        actionFigure: "فیگور اکشن",
        actionFigureDesc: "قهرمانانشان را به کلکسیون‌های حماسی آماده ماجراجویی تبدیل کنید!",
        lego: "سبک لگو",
        legoDesc: "قطعه به قطعه، تخیل آن‌ها به شخصیت ساختنی جاودان تبدیل می‌شود.",
        anime: "سبک انیمه",
        animeDesc: "جادوی انیمیشن ژاپنی را با چشم‌های پرحالت و ژست‌های پویا زنده کنید.",
        pixar: "پیکسار سه‌بعدی",
        pixarDesc: "جادوی سینما با واقعیت - هر کسی را به شخصیت انیمیشنی دوست‌داشتنی تبدیل کنید.",
        funko: "فانکو پاپ",
        funkoDesc: "به محبوب‌ترین سبک کلکسیونی جهان بپیوندید!",
        chibi: "فیگور چیبی",
        chibiDesc: "سرریز از زیبایی کاوایی با سرهای بزرگ دوست‌داشتنی و بدن‌های کوچک.",
        vinyl: "اسباب‌بازی وینیل",
        vinylDesc: "حس اسباب‌بازی هنری طراح با زیبایی‌شناسی شیک.",
        legoPhoto: "سبک لگو",
        legoPhotoDesc: "مینی‌فیگور شوید! بهترین تقدیر به اسباب‌بازی محبوب جهان.",
        watercolor: "آبرنگ",
        watercolorDesc: "قلم‌موهای نرم و رویایی نقاشی‌شان را در دنیای ملایم کتاب داستان زنده می‌کنند.",
        cartoonStory: "کارتونی",
        cartoonStoryDesc: "خطوط برجسته و رنگ‌های شاد هنرشان را به ماجراجویی انیمیشنی تبدیل می‌کنند.",
        crayon: "مدادشمعی",
        crayonDesc: "ضربه‌های گرم مدادشمعی جذابیت دست‌ساز را در هر تصویر حفظ می‌کنند.",
        classic: "کلاسیک",
        classicDesc: "تصاویر جاودانه کتاب داستان با جزئیات غنی و گرمای نوستالژیک.",
        animeStory: "انیمه",
        animeStoryDesc: "هنر پرحالت الهام‌گرفته از مانگا شخصیت‌هایشان را به دنیای داستان پویا می‌آورد.",
      },
    },
    features: {
      title: "ساخته شده برای شادی. ساخته شده برای اعتماد.",
      subtitle: "هر جزئیات با والدین، ایمنی و بازی واقعی در ذهن طراحی شده",
      kidAuthentic: {
        title: "هوش مصنوعی اصیل کودکانه",
        description: "هوش مصنوعی ما هر ویژگی را حفظ می‌کند — اژدهای سه‌پا، تاج‌های کج و همه چیز. ما بهبود می‌دهیم، هرگز اصلاح نمی‌کنیم.",
      },
      preview: {
        title: "پیش‌نمایش قبل از چاپ",
        description: "پیش‌نمایش سه‌بعدی تعاملی ببینید و قبل از شروع تولید ویرایش کنید. شما هر جزئیات را تأیید می‌کنید.",
      },
      childSafe: {
        title: "مواد ایمن برای کودکان",
        description: "PLA بدون BPA، رزین غیر سمی، مطابق با CE. هر ماده به طور مستقل برای دست‌های کوچک آزمایش شده.",
      },
      trackedDelivery: {
        title: "ارسال قابل پیگیری",
        description: "استاندارد ۱۰-۱۴ روز، اکسپرس ۵-۷ روز. پیگیری لحظه‌ای از کارگاه ما تا درب خانه شما.",
      },
      ecoFriendly: {
        title: "گزینه‌های سازگار با محیط زیست",
        description: "PLA زیست‌تجزیه‌پذیر گیاهی و بسته‌بندی بازیافتی. ساخته شده برای بازی، مهربان با سیاره.",
      },
      happiness: {
        title: "تضمین رضایت",
        description: "دوستش داشته باشید یا رایگان دوباره می‌سازیم. بدون سؤال، بدون مانع، بدون دردسر.",
      },
    },
    testimonials: {
      title: "خانواده‌ها عاشق یادگاری‌هایشان هستند",
      subtitle: "به هزاران والدینی بپیوندید که هنر یخچال را ماندگار کردند",
      verifiedPurchase: "خرید تأیید شده",
      trustAnchor: "۴.۹ از ۵ از بیش از ۵۰۰ خانواده",
      familyCount: "از بیش از ۲۰۰ خانواده راضی",
      microReviews: [
        "دخترم از خوشحالی جیغ کشید! ⭐⭐⭐⭐⭐",
        "کیفیت بهتر از انتظارم بود",
        "پیش‌نمایش دقیقاً همان چیزی بود که رسید",
        "دارم دومی را سفارش می‌دهم",
        "بهترین هدیه تولد تاکنون",
        "۶ روزه رسید، بسته‌بندی عالی",
        "پسرم فکر می‌کند واقعاً مخترع شده",
        "ارزش هر ریالش را داشت"
      ],
      readAllReviews: "خواندن همه نظرات",
      items: {
        sarah: { name: "سارا م.", text: "دخترم واقعاً اشک شادی ریخت. نمی‌توانست باور کند که شاهزاده اژدهایش واقعی شده. الان گران‌قیمت‌ترین دارایی‌اش است." },
        james: { name: "جیمز ک.", text: "نقاشی پسرم از سگمان را به فیگور تبدیل کردیم. فوق‌العاده جزئیات دارد — حتی قلاده کوچکش را دارد. با افتخار روی میز کنار تختش نشسته." },
        emily: { name: "امیلی ر.", text: "بهترین هدیه‌ای که به نوه‌هایم دادم. با هم شخصیت‌ها را طراحی کردند و الان هر روز باهاشون بازی می‌کنند. جادوی خالص." },
        maria: { name: "ماریا ل.", text: "سه اسباب‌بازی از نقاشی‌های بچه‌هایم سفارش دادم. کیفیت من را شگفت‌زده کرد — دقیقاً شبیه آنچه بچه‌هایم تصور کرده بودند. در حال سفارش بیشتر هستم." },
      },
    },
    cta: {
      eyebrow: "آماده‌اید؟",
      title: "تخیل آن‌ها لایق واقعی شدن است",
      subtitle: "در ۳۰ ثانیه نقاشی آپلود کنید. پیش‌نمایش سه‌بعدی رایگان بگیرید. بدون نیاز به حساب کاربری.",
      button: "جادو را شروع کنید",
      trustSignals: "🛡️ ایمن برای کودکان  |  🚚 ارسال رایگان بالای ۷۵  |  💚 تضمین رضایت",
      handwritten: "آماده شروع هستید؟",
      trustFreePreview: "پیش‌نمایش رایگان",
      trustSecureCheckout: "پرداخت امن",
      trustTrackedShipping: "ارسال قابل پیگیری",
      trustHappinessGuarantee: "تضمین رضایت",
    },
    delivery: {
      title: "از کارگاه ما تا درب منزل شما",
      subtitle: "ارسال سریع، قابل پیگیری و سازگار با محیط زیست — چون انتظار باید به اندازه باز کردن جعبه هیجان‌انگیز باشد.",
      steps: {
        order: {
          title: "ثبت سفارش",
          desc: "طرح شما به صورت امن دریافت و برای ساخت صف‌بندی می‌شود.",
        },
        craft: {
          title: "ساخت دستی",
          desc: "سازندگان ما با دقت و مراقبت اثر هنری شما را زنده می‌کنند.",
        },
        pack: {
          title: "بسته‌بندی دقیق",
          desc: "بسته‌بندی سازگار با محیط زیست با محافظ برای ایمنی.",
        },
        ship: {
          title: "ارسال و پیگیری",
          desc: "لینک پیگیری به محض ارسال اسباب‌بازی برای شما ارسال می‌شود.",
        },
      },
      perks: {
        fast: {
          title: "تحویل ۵ تا ۷ روزه",
          desc: "سفارشات آمریکا، انگلیس و اروپا ظرف یک هفته می‌رسد.",
        },
        worldwide: {
          title: "ارسال جهانی",
          desc: "ما به بیش از ۱۲۰ کشور ارسال می‌کنیم.",
        },
        tracked: {
          title: "کاملاً قابل پیگیری",
          desc: "پیگیری لحظه‌ای از ارسال تا تحویل.",
        },
      },
    },
  },

  howItWorks: {
    hero: {
      title: "از نقاشی تا درب خانه در ۴ مرحله",
      subtitle: "نیازی به مهارت فنی نیست. بدون نیاز به حساب کاربری.",
    },
    steps: {
      capture: {
        title: "نقاشی را ثبت کنید",
        description: "آن اثر هنری گران‌قدار را از یخچال، دفتر نقاشی یا تبلت بردارید. هر خط مداد، هر ایده وحشی -- دقیقاً همان‌طور که تصورش کردند زنده می‌کنیم.",
        highlights: ["هر نقاشی کار می‌کند -- نامرتب هم خوش‌آمد!", "هنر دیجیتال یا شاهکارهای کاغذی", "حتی خط‌خطی روی دستمال هم گنج می‌شود"],
      },
      share: {
        title: "در ۳۰ ثانیه آپلود کنید",
        description: "در چند ثانیه عکس بگیرید یا اثرشان را آپلود کنید. رابط کاربری دوستانه ما راهنمایی می‌کند -- نیازی به مهارت فنی نیست. فقط هیجان خالص!",
        highlights: ["آپلود ۳۰ ثانیه‌ای", "ذخیره‌سازی امن و ایمن", "فوراً پیش‌نمایش ببینید"],
      },
      magic: {
        title: "جادو را ببینید",
        description: "جادوگران هوش مصنوعی ما هر جزئیات را مطالعه می‌کنند، خلأها را پر می‌کنند و بُعد اضافه می‌کنند در حالی که سبک منحصربه‌فردشان را حفظ می‌کنند. سپس صنعتگران ما با عشق چاپ سه‌بعدی می‌کنند.",
        highlights: ["هوش مصنوعی دیدگاه هنری را حفظ می‌کند", "چاپ سه‌بعدی حرفه‌ای", "بازبینی و درخواست تغییرات"],
      },
      unbox: {
        title: "شادی خالص را باز کنید",
        description: "آن لحظه که بسته می‌رسد... وقتی می‌فهمند تخیلشان الان واقعی است. این‌ها خاطراتی هستند که برای همیشه می‌مانند.",
        highlights: ["در ۷-۱۰ روز می‌رسد", "با عشق بسته‌بندی شده", "هر قدم سفر را دنبال کنید"],
      },
    },
    features: {
      title: "چرا خانواده‌ها روبی را انتخاب می‌کنند",
      subtitle: "ما وسواسی هر جزئیات را انجام می‌دهیم تا شما روی لبخندها تمرکز کنید",
      items: ["مواد ۱۰۰٪ ایمن کودک و غیرسمی", "رنگ‌های درخشان که محو نمی‌شوند", "به اندازه کافی محکم برای بازی واقعی", "تضمین رضایت یا بازگشت کامل وجه", "گزینه‌های سازگار با محیط زیست", "اندازه‌های مختلف"],
    },
    cta: {
      title: "آماده خلق جادو هستید؟",
      subtitle: "شاهکار بعدی‌شان منتظر واقعی شدن است. الان شروع کنید و خاطراتی بسازید که یک عمر می‌ماند.",
      startButton: "شروع خلق",
      pricingButton: "مشاهده قیمت‌ها",
    },
  },

  pricing: {
    hero: {
      title: "یادگاری خود را انتخاب کنید",
      subtitle: "قیمت‌گذاری ساده. کیفیت برتر. بدون هزینه پنهان.",
    },
    packages: {
      free: "رایگان",
      perToy: "اسباب‌بازی",
      mostPopular: "محبوب‌ترین",
      cta: { free: "جادو را ببینید", starter: "شروع کنید", premium: "شروع خلق", deluxe: "ویژه شوید" },
    },
    addOns: {
      title: "گزینه‌های سفارشی‌سازی",
      subtitle: "اسباب‌بازی فیزیکی خود را با این گزینه‌ها شخصی‌سازی کنید",
      items: { extraSize: "گزینه‌های اندازه اضافی", displayCase: "قاب نمایش محافظ", rush: "پردازش فوری (۳-۵ روز)", additionalCopy: "نسخه اضافی" },
      categories: {
        size: "گزینه‌های اندازه",
        material: "گزینه‌های متریال",
        color_plan: "گزینه‌های رنگ",
        extra: "گزینه‌های اضافی",
      },
      included: "شامل قیمت پایه",
      discount: "۱۰٪ تخفیف",
    },
    guarantees: {
      items: {
        satisfaction: { title: "رضایت ۱۰۰٪", description: "راضی باشید یا بازگشت کامل وجه" },
        shipping: { title: "ارسال رایگان", description: "برای سفارش‌های بالای ۷۵ پوند" },
        delivery: { title: "تحویل به‌موقع", description: "یا پولتان برمی‌گردد" },
      },
    },
    shipping: {
      title: "ارسال و زمان‌بندی",
      options: { title: "گزینه‌های ارسال", standard: "ارسال استاندارد: رایگان (۱۰-۱۴ روز)", express: "ارسال سریع: ۱۵ دلار (۷-۱۰ روز)", rush: "ارسال فوری: ۳۰ دلار (۵-۷ روز)" },
      timeline: { title: "زمان‌بندی تولید", ai: "پردازش هوش مصنوعی: ۲۴-۴۸ ساعت", printing: "چاپ سه‌بعدی: ۲-۴ روز", painting: "پرداخت و بسته‌بندی: ۱-۲ روز", quality: "بررسی کیفیت: ۱ روز" },
    },
    pageCta: { title: "آماده شروع خلق هستید؟", subtitle: "نقاشی‌تان را آپلود کنید و جادو را ببینید", button: "نقاشی‌تان را آپلود کنید" },
  },

  about: {
    hero: {
      title: "ما باور داریم هر نقاشی لایق واقعی شدن است",
      subtitle: "روبی تخیل کودک شما را به اسباب‌بازی‌های چاپ سه‌بعدی سفارشی، کتاب‌های داستان شخصی‌سازی‌شده و فیلم‌های انیمیشن کوتاه تبدیل می‌کند — همگی از یک نقاشی یا عکس ساده.",
    },
    mission: {
      title: "ماموریت ما",
      text: "کودکی زودگذر است. آن شاهکارهای مدادرنگی روی یخچال محو می‌شوند، گم می‌شوند، در جعبه‌های زیرشیروانی فراموش می‌شوند. ما اجازه نمی‌دهیم این اتفاق بیفتد. چه به‌صورت اسباب‌بازی‌ای که کودکتان در دست بگیرد، چه کتابی با نام او روی جلد، چه فیلم انیمیشنی که نقاشی‌اش در آن بازی کند — روبی لحظات گذرای خلاقیت را به چیزی تبدیل می‌کند که خانواده‌ها برای همیشه نگه می‌دارند.",
    },
    vision: {
      title: "چشم‌انداز ما",
      text: "دنیایی که در آن تخیل هر کودکی جشن گرفته شود — جایی که هیچ نقاشی «فقط یک نقاشی» نباشد، و خلاقیت چیزی باشد که بتوانید لمس کنید، بخوانید، تماشا کنید و برای یک عمر گنجینه کنید.",
    },
    values: {
      title: "ارزش‌های ما",
      subtitle: "بیش از یک شرکت، ما قولی به هر کودک خلاق هستیم",
      items: {
        kids: { title: "کودکان اول", description: "هر تصمیمی — فیزیکی یا دیجیتال — با یک سوال شروع می‌شود: «آیا این کودک را خوشحال می‌کند؟»" },
        imagination: { title: "تخیل مهم است", description: "هر خط‌خطی داستانی دارد. ما از هوش مصنوعی برای تقویت دیدگاه کودک استفاده می‌کنیم، نه جایگزینی آن." },
        safety: { title: "همیشه ایمن", description: "مواد ایمن برای اسباب‌بازی، بازبینی محتوای متناسب با سن برای کتاب و انیمیشن. والدین در هر مرحله کنترل دارند." },
        planet: { title: "دوستدار سیاره", description: "مواد زیست‌تجزیه‌پذیر برای اسباب‌بازی‌های فیزیکی و رندر ابری بهینه برای محصولات دیجیتال." },
      },
    },
    journey: {
      title: "سفر ما تاکنون",
      subtitle: "از آرزوی یک والد تا یک استودیوی خلاق چندمحصوله برای خانواده‌ها",
      items: {
        sketch: { event: "اولین نقاشی", description: "روبی با آرزوی یک والد شروع شد: «می‌خواهم دخترم نقاشی اژدهایش را در دست بگیرد.»" },
        thousand: { event: "۱۰۰۰ رویا واقعی شد", description: "اولین هزار خانواده ما شادی نگه‌داشتن هنر کودکشان به‌صورت اسباب‌بازی واقعی را تجربه کردند." },
        ai: { event: "دقت مبتنی بر هوش مصنوعی", description: "خط‌تولید سه‌بعدی چندنمای ۴K را راه‌اندازی کردیم که هر ویژگی نقاشی اصلی را حفظ می‌کند." },
        storybook: { event: "کتاب‌های داستان از راه رسیدند", description: "کتاب‌های تصویری شخصی‌سازی‌شده با تصویرگری هوش مصنوعی و روایت دوزبانه فارسی/انگلیسی — کودک شما به‌عنوان قهرمان." },
        animation: { event: "فیلم‌های انیمیشن منتشر شدند", description: "از یک نقاشی یا عکس به یک فیلم کوتاه کارگردانی‌شده با صحنه‌ها، صداها و موسیقی." },
      },
    },
    promise: {
      text: "اگر بتوانند بکشند، شما می‌توانید نگهش دارید، بخوانیدش و تماشایش کنید.",
    },
    cta: {
      title: "جادوی خود را انتخاب کنید",
      subtitle: "اسباب‌بازی، کتاب داستان یا فیلم انیمیشن — سه راه برای تبدیل خلاقیت کودکتان به چیزی ماندگار.",
      button: "شروع خلق",
    },
  },

  gallery: {
    hero: { badge: "دیوار شگفتی", title: "تخیل", titleHighlight: "ملموس شده", subtitle: "هر اسباب‌بازی اینجا با نقاشی یک کودک واقعی شروع شد. این‌ها داستان‌های آن‌هاست." },
    createdBy: "ساخته شده توسط",
    loadMore: "کشف آثار بیشتر",
    categories: { cartoon: "کارتونی", action: "اکشن", plush: "عروسکی", realistic: "واقع‌گرایانه" },
    items: {
      dragon: { title: "سر اسکیلز شجاع", artist: "امیلی، ۷ ساله", story: "امیلی این اژدها را کشید تا برادر کوچکش را از کابوس‌ها محافظت کند. الان نگهبان میز کنار تختش است!" },
      captain: { title: "کاپیتان استارداست", artist: "مارکوس، ۹ ساله", story: "مارکوس این ابرقهرمان را اختراع کرد که می‌تواند در فضا پرواز کند و بستنی نامحدود بخورد." },
      fluffy: { title: "فلافی مک‌هاگفیس", artist: "صوفیا، ۶ ساله", story: "دوست خیالی صوفیا الان واقعی است! همه جا می‌بردش، حتی به مدرسه." },
      robot: { title: "روبو-بادی ۳۰۰۰", artist: "لوکاس، ۸ ساله", story: "لوکاس می‌خواهد مخترع شود. این اولین ربات «واقعی»اش است، مستقیم از دفتر نقاشی‌اش." },
      princess: { title: "پرنسس اسپارکل‌هورن", artist: "آوا، ۷ ساله", story: "یک شاهزاده یونیکورن جادویی که آرزوها را برآورده می‌کند. آوا می‌گوید تا الان ۴۷ آرزو برآورده کرده!" },
      flex: { title: "فلکس باورنکردنی", artist: "نوح، ۱۰ ساله", story: "ابرقهرمان اصلی نوح با قدرت‌های کشسانی. دارد شخصیت دنباله را برنامه‌ریزی می‌کند!" },
    },
    stats: {
      dreams: { value: "+۱۰،۰۰۰", label: "رویا به واقعیت پیوسته" },
      countries: { value: "+۵۰", label: "کشور پوشش داده شده" },
      rating: { value: "۴.۹/۵", label: "امتیاز خانواده‌های راضی" },
    },
    cta: { title: "اثر فرزندتان می‌تواند اینجا باشد", subtitle: "هر شاهکار لایق بیش از یک نقاشی بودن است. امروز آپلود کنید و به گالری تخیل ما بپیوندید.", button: "شروع خلق" },
  },

  faq: {
    hero: { badge: "سوال دارید؟ جواب داریم!", title: "هر آنچه", titleHighlight: "می‌خواهید بدانید", subtitle: "سوالات واقعی از والدین واقعی (و چند پدربزرگ و مادربزرگ کنجکاو!)" },
    categories: {
      gettingStarted: {
        title: "شروع کار",
        questions: {
          messy: { q: "نقاشی بچه‌ام خیلی نامرتب است. باز هم کار می‌کند؟", a: "قطعاً! نامرتب زیباست - جادو همانجاست! هوش مصنوعی ما آموزش دیده تا هنر کودکان را در تمام آشفتگی شگفت‌انگیزش درک کند." },
          upload: { q: "چطور نقاشی را برایتان بفرستم؟", a: "خیلی راحت! فقط با گوشی عکس بگیرید یا اسکن کنید. از طریق سایت آپلود کنید (حدود ۳۰ ثانیه طول می‌کشد)، سبک را انتخاب کنید و تمام!" },
          preview: { q: "می‌توانم قبل از سفارش ببینم چطور می‌شود؟", a: "بله! در عرض چند دقیقه، هوش مصنوعی ما پیش‌نمایش سه‌بعدی می‌سازد تا جادو را در حال وقوع ببینید. می‌توانید تغییرات بخواهید تا کامل شود." },
        },
      },
      pricing: {
        title: "قیمت و پرداخت",
        questions: {
          cost: { q: "یک اسباب‌بازی سفارشی چقدر است؟", a: "اسباب‌بازی‌ها از ۴۹ پوند برای فیگور کوچک تک‌رنگ شروع می‌شوند. بیشتر خانواده‌ها بسته ۷۹ پوندی تمام‌رنگی با مقاوم‌ترین جنس را انتخاب می‌کنند. کتاب‌های داستان و فیلم‌های انیمیشن از پلن جداگانه مبتنی بر اعتبار استفاده می‌کنند — برای همه گزینه‌ها صفحه قیمت‌گذاری را ببینید." },
          hidden: { q: "هزینه پنهانی وجود دارد؟", a: "نه! از سورپرایز متنفریم. قیمتی که می‌بینید شامل اسباب‌بازی، بسته‌بندی زیبا و ارسال است." },
          notLike: { q: "اگر بچه‌ام خوشش نیاید؟", a: "تضمین ۱۰۰٪ رضایت داریم. اگر فرزندتان ذوق‌زده نشد، ظرف ۳۰ روز تماس بگیرید و درستش می‌کنیم." },
          payment: { q: "می‌توانم با PayPal/Apple Pay پرداخت کنم؟", a: "بله! همه کارت‌های اعتباری اصلی، PayPal، Apple Pay و Google Pay را قبول می‌کنیم. همه چیز از طریق Stripe امن است." },
        },
      },
      production: {
        title: "تولید و ارسال",
        questions: {
          timeline: { q: "چقدر طول می‌کشد تا بچه‌ام اسباب‌بازی‌اش را بگیرد؟", a: "جادوی استاندارد ۱۰-۱۴ روز از وقتی طرح را تأیید کنید طول می‌کشد. نمی‌توانید صبر کنید؟ گزینه فوری ظرف ۵-۷ روز می‌رساند!" },
          shipping: { q: "به کشور من ارسال می‌کنید؟", a: "به بیش از ۵۰ کشور جهان جادو ارسال می‌کنیم! سفارش‌های بین‌المللی معمولاً ۲-۳ هفته می‌رسند." },
          tracking: { q: "می‌توانم سفارشم را پیگیری کنم؟", a: "البته! به محض ارسال کد پیگیری می‌گیرید، به‌علاوه صفحه اختصاصی پیگیری سفارش داریم." },
          damaged: { q: "اگر آسیب‌دیده برسد چی؟", a: "همه چیز را مثل اسباب‌بازی‌های بچه‌های خودمان بسته‌بندی می‌کنیم. اما اگر اتفاقی افتاد، ظرف ۷ روز عکس بگیرید و تماس بگیرید." },
        },
      },
      product: {
        title: "جزئیات محصول",
        questions: {
          materials: { q: "اسباب‌بازی‌ها از چه ساخته شده؟ ایمن است؟", a: "ایمنی غیرقابل مذاکره است. از PLA (پلاستیک گیاهی تجزیه‌پذیر)، PETG یا رزین با جزئیات بالا استفاده می‌کنیم. همه مواد استانداردهای بین‌المللی ایمنی اسباب‌بازی را دارند." },
          play: { q: "بچه‌ام واقعاً می‌تواند باهاش بازی کند؟", a: "همین هدف ماست! اسباب‌بازی‌های PLA و PETG استاندارد ما برای بازی سخت ساخته شده‌اند - انداختن، پرتاب کردن، ماجراجویی در حیاط." },
          sizes: { q: "چه اندازه‌هایی دارید؟", a: "چهار اندازه داریم: کوچک (۱۰-۱۵ سانتی)، متوسط (۱۵-۲۰ سانتی)، بزرگ (۲۰-۳۰ سانتی) و اندازه سفارشی برای درخواست‌های خاص!" },
          copies: { q: "می‌توانم کپی برای پدربزرگ و مادربزرگ سفارش دهم؟", a: "بهترین هدیه! کپی‌های اضافی از همان طرح ۵۰٪ تخفیف دارند. مادربزرگ، عمه، عموزاده‌ها... همه می‌توانند داشته باشند." },
        },
      },
      customization: {
        title: "شخصی‌سازی",
        questions: {
          changes: { q: "می‌توانم تغییرات در مدل سه‌بعدی بخواهم؟", a: "قطعاً! در مرحله پیش‌نمایش می‌توانید تغییرات بخواهید. بسته‌های Premium و Deluxe ویرایش نامحدود دارند." },
          colors: { q: "می‌توانم رنگ‌ها را انتخاب کنم؟", a: "برای بسته‌های رنگ کامل، رنگ‌ها را از نقاشی اصلی تطبیق می‌دهیم. برای گزینه‌های تک‌رنگ، از بیش از ۲۰ رنگ درخشان انتخاب کنید." },
          family: { q: "بچه‌ام کل خانواده را کشیده. می‌توانید بسازید؟", a: "عاشق پرتره‌های خانوادگی هستیم! چند شخصیت می‌توانند در یک صحنه ترکیب شوند یا فیگورهای جداگانه باشند." },
        },
      },
      safety: {
        title: "ایمنی و کیفیت",
        questions: {
          toddler: { q: "برای کودک نوپایم ایمن است؟", a: "ایمنی را جدی می‌گیریم. اسباب‌بازی‌هایمان استانداردهای بین‌المللی ایمنی را دارند، اما برای سنین ۳+ توصیه می‌کنیم." },
          quality: { q: "چطور مطمئن می‌شوید کیفیت ثابت است؟", a: "هر اسباب‌بازی سه بررسی کیفیت دارد: بعد از چاپ، بعد از پرداخت و قبل از ارسال." },
          guarantee: { q: "تضمین شما چیست؟", a: "ساده: دوستش داشته باشید یا درستش می‌کنیم. اگر از اسباب‌بازی‌تان راضی نیستید، رایگان دوباره می‌سازیم یا پول برمی‌گردانیم." },
        },
      },
    },
    support: {
      title: "هنوز کنجکاو هستید؟",
      subtitle: "تیم دوستانه ما عاشق صحبت با خانواده‌هاست. هیچ سوالی کوچک نیست!",
      chat: { title: "چت با ما", description: "انسان‌های واقعی، کمک فوری. میانگین پاسخ: ۲ دقیقه!", button: "شروع چت" },
      email: { title: "ایمیل به ما", description: "ایمیل ترجیح می‌دهید؟ ظرف ۲۴ ساعت پاسخ می‌دهیم", button: "ارسال ایمیل" },
    },
  },

  contact: {
    hero: { badge: "کنارتان هستیم", title: "بیایید", titleHighlight: "صحبت کنیم!", subtitle: "سوال درباره سفارش؟ ایده برای خلق بعدی؟ فقط می‌خواهید واکنش بچه‌تان را به اشتراک بگذارید؟ دوست داریم خبری از شما داشته باشیم!" },
    methods: {
      email: { title: "ایمیل به ما", description: "ظرف ۲۴ ساعت پاسخ می‌دهیم - قول می‌دهیم!" },
      phone: { title: "تماس بگیرید", description: "انسان‌های واقعی، دوشنبه-جمعه ۹ صبح تا ۶ عصر" },
      chat: { title: "چت زنده", value: "الان چت کنید", description: "میانگین انتظار: فقط ۲ دقیقه!" },
      visit: { title: "از کارگاه دیدن کنید", description: "تورها با قرار قبلی - بیایید جادو را ببینید!" },
    },
    form: {
      title: "پیام بفرستید",
      subtitle: "شخصاً هر پیامی را می‌خوانیم!",
      name: { label: "نام شما", placeholder: "چه صدایتان کنیم؟" },
      email: { label: "آدرس ایمیل", placeholder: "your@email.com" },
      subject: { label: "موضوع چیست؟", placeholder: "سوال سفارش، ایده جدید، بازخورد..." },
      message: { label: "پیامتان", placeholder: "همه چیز را بگویید! شنونده خوبی هستیم..." },
      submit: "ارسال پیام",
      submitting: "در حال ارسال پیام...",
      success: { title: "پیام ارسال شد! 💌", description: "ظرف ۲۴ ساعت پاسخ می‌دهیم. ممنون که تماس گرفتید!" },
      error: { title: "اوه!", description: "مشکلی پیش آمد. لطفاً دوباره امتحان کنید یا مستقیم ایمیل بزنید." },
      errors: {
        nameRequired: "نام الزامی است",
        nameTooLong: "نام باید کمتر از ۱۰۰ کاراکتر باشد",
        emailInvalid: "آدرس ایمیل نامعتبر",
        emailTooLong: "ایمیل باید کمتر از ۲۵۵ کاراکتر باشد",
        subjectRequired: "موضوع الزامی است",
        subjectTooLong: "موضوع باید کمتر از ۲۰۰ کاراکتر باشد",
        messageTooShort: "پیام باید حداقل ۱۰ کاراکتر باشد",
        messageTooLong: "پیام باید کمتر از ۱۰۰۰ کاراکتر باشد",
      },
    },
    hours: { title: "ساعات کاری", weekdays: "دوشنبه – جمعه: ۹:۰۰ – ۱۸:۰۰ به وقت گرینویچ", saturday: "شنبه: ۱۰:۰۰ – ۱۶:۰۰ به وقت گرینویچ", sunday: "یکشنبه: در حال شارژ — ایمیل بزنید، دوشنبه پاسخ می‌دهیم" },
    quickAnswers: { title: "پاسخ‌های سریع", faq: "سوالات متداول را ببینید - کلی سوال جواب دادیم!", track: "وضعیت سفارش را پیگیری کنید", howItWorks: "ببینید جادو چطور کار می‌کند", pricing: "بسته‌های قیمت را ببینید" },
    urgent: { title: "مشکل فوری سفارش؟", description: "اگر مشکلی در سفارشتان هست، منتظر نمانید! برای کمک فوری وارد چت زنده شوید.", button: "الان چت زنده را شروع کنید" },
  },

  reviews: {
    hero: { badge: "داستان‌های واقعی، جادوی واقعی", title: "محبوب خانواده‌ها", titleHighlight: "در سراسر دنیا", subtitle: "از اسباب‌بازی‌های بغلی تا کتاب داستان شب‌خواب و فیلم‌های انیمیشن کوتاه — ببینید خانواده‌ها با روبی چه ساخته‌اند." },
    rating: { basedOn: "بر اساس {total} نظر تأیید شده", recommend: "۹۷٪ از خانواده‌ها ما را توصیه می‌کنند!" },
    verified: "تأیید شده",
    helpful: "{count} نفر این را مفید یافتند",
    loadMore: "داستان‌های بیشتر",
    items: {
      sarah: { name: "سارا م.", location: "نیویورک", title: "دخترم از خوشحالی گریه کرد!", review: "نمی‌توانم بگویم این لحظه چقدر جادویی بود. دختر ۷ ساله‌ام ماه‌ها پیش یک شاهزاده یونیکورن کشید و من مخفیانه از روبی خواستم اسباب‌بازی بسازد. وقتی برای تولدش بازش کرد، واقعاً نمی‌توانست چشمانش را باور کند.", date: "۲ هفته پیش" },
      michael: { name: "مایکل ر.", location: "آستین، تگزاس", title: "حتی بهتر از تصورم", review: "پسرم سگ گلدن رتریورمان را با تناسب معمول ۶ ساله‌ها کشید (سر غول‌پیکر، پاهای ریز). مطمئن نبودم چطور ترجمه می‌شود، اما روبی عالی در آورد.", date: "۱ ماه پیش" },
      emily: { name: "امیلی ل.", location: "لس‌آنجلس", title: "خدمات مشتری هم عالی است!", review: "دخترم یک ابرقهرمان کشید و ما می‌خواستیم تغییر کوچکی در شنل بدهیم. تیم خیلی صبور بود با درخواست‌هایمان - ۳ بار ویرایش کردیم.", date: "۳ هفته پیش" },
      david: { name: "دیوید ک.", location: "شیکاگو", title: "مفهوم عالی، اجرای محکم", review: "پرتره خانوادگی مدادرنگی دخترم را به فیگور تبدیل کردم. هوش مصنوعی کار فوق‌العاده‌ای کرد در تفسیر انتخاب‌های آناتومی... خلاقانه‌اش برای همه ما.", date: "۱ هفته پیش" },
      jennifer: { name: "جنیفر پ.", location: "میامی", title: "زندگی برادرزاده‌ام را عوض کرد", review: "برادرزاده‌ام اوتیسم دارد و نقاشی راه ارتباطی‌اش است. ربات‌های با جزئیات باورنکردنی می‌سازد. تبدیل یکی از نقاشی‌هایش به اسباب‌بازی واقعی برایش تحول‌آفرین بود.", date: "۲ ماه پیش" },
      robert: { name: "رابرت س.", location: "سیاتل", title: "کیفیت تأیید شده مهندسی", review: "من مهندس هستم، پس طبیعتاً شکاک و سخت‌گیر درباره کیفیت ساخت هستم. این اسباب‌بازی از انتظاراتم فراتر رفت.", date: "۳ هفته پیش" },
    },
    cta: { title: "آماده خلق داستان خودتان هستید؟", subtitle: "به هزاران خانواده‌ای بپیوندید که تخیل را به یادگارهای گران‌قیمت تبدیل کرده‌اند", button: "جادویتان را شروع کنید" },
  },

  footer: {
    brand: "روبی",
    tagline: "از یخچال تا جاودانگی",
    create: { title: "بسازید", fromDrawing: "از نقاشی", fromPhoto: "از عکس", storybook: "ساخت کتاب داستان", giftCards: "کارت هدیه" },
    learnMore: { title: "بیشتر بدانید", howItWorks: "چگونه کار می‌کند", gallery: "گالری", pricing: "قیمت‌ها", qualitySafety: "کیفیت و ایمنی" },
    support: { title: "پشتیبانی", faq: "سوالات متداول", contact: "تماس با ما", track: "پیگیری سفارش", reviews: "نظرات" },
    copyright: "© ۲۰۲۶ روبی. تمامی حقوق محفوظ است.",
    legal: { terms: "شرایط", privacy: "حریم خصوصی", cookies: "کوکی‌ها" },
    newsletter: { title: "الهام خلاقانه دریافت کنید", button: "عضویت", emailPlaceholder: "ایمیل شما" },
  },

  terms: {
    badge: "مسائل حقوقی",
    title: "شرایط خدمات",
    subtitle: "جزئیات خسته‌کننده (اما مهم) درباره استفاده از روبی",
    lastUpdated: "آخرین به‌روزرسانی",
    sections: {
      welcome: { title: "۱. خوش آمدید به روبی!", content: "با استفاده از روبی، با این شرایط خدمات موافقت می‌کنید. می‌دانیم اسناد حقوقی خواندنش سرگرم‌کننده نیست، اما این شرایط از شما و ما محافظت می‌کند." },
      whatWeDo: { title: "۲. کار ما چیست", content: "روبی نقاشی‌ها و عکس‌ها را به سه نوع یادگاری تبدیل می‌کند: اسباب‌بازی‌های چاپ سه‌بعدی سفارشی، کتاب‌های داستان شخصی‌سازی‌شده با تصویرگری هوش مصنوعی (با روایت دوزبانه اختیاری)، و فیلم‌های انیمیشن کوتاه. وقتی محتوا آپلود می‌کنید و سفارش می‌دهید یا اعتبار خرج می‌کنید، از ما می‌خواهید آن محصول فیزیکی یا تحویل دیجیتال خاص را بسازیم." },
      yourArtwork: { title: "۳. اثر شما، حقوق شما", ownership: "مالکیت هر اثر اصلی آپلودی با شماست. با آپلود، به ما اجازه می‌دهید از آن اثر فقط برای:", items: ["ساخت اسباب‌بازی سفارشی شما", "نمایش پیش‌نمایش در فرآیند ساخت", "با اجازه شما، نمایش در گالری ما"], important: "مهم: فقط آثاری آپلود کنید که حق استفاده از آن‌ها را دارید. شخصیت‌های دارای کپی‌رایت را آپلود نکنید مگر مالک حقوق باشید." },
      models: { title: "۴. مدل‌های سه‌بعدی ما", content: "مدل‌های سه‌بعدی که می‌سازیم کار مشترک است. شما مالک مفهوم اصلی هستید و ما حقوق مدل سه‌بعدی را نگه می‌داریم." },
      orders: { title: "۵. سفارشات و پرداخت", pricing: { label: "قیمت‌گذاری:", content: "قیمت‌ها قبل از سفارش واضح نمایش داده می‌شود. هزینه پنهان نداریم." }, payment: { label: "پرداخت:", content: "پرداخت کامل قبل از شروع تولید لازم است." }, custom: { label: "ماهیت سفارشی:", content: "هر اسباب‌بازی مخصوصاً برای شما ساخته می‌شود." }, approval: { label: "تأیید:", content: "شما پیش‌نمایش سه‌بعدی را قبل از چاپ تأیید می‌کنید." } },
      revisions: { title: "۶. ویرایش و تغییرات", content: "در مرحله پیش‌نمایش، می‌توانید تغییرات بخواهید. بعد از تأیید و شروع چاپ، تغییر ممکن نیست." },
      guarantee: { title: "۷. تضمین رضایت ما", intro: "می‌خواهیم از اسباب‌بازی‌تان ذوق‌زده شوید. اگر مشکلی باشد:", items: ["عیوب تولید: تعویض رایگان، بدون سوال", "آسیب ارسال: تعویض رایگان با عکس مدرک ظرف ۷ روز", "راضی نیستید: ظرف ۳۰ روز تماس بگیرید برای بازگشت وجه یا ساخت مجدد"], note: "برای طرح‌های تأیید شده که بعداً نظرتان عوض شود بازگشت وجه نداریم." },
      shipping: { title: "۸. ارسال و تحویل", items: ["زمان تحویل تخمینی بعد از تأیید سفارش اعلام می‌شود", "به بیش از ۵۰ کشور جهان ارسال می‌کنیم", "بعد از ارسال، اطلاعات پیگیری ارائه می‌شود", "تأخیرات گمرکی خارج از کنترل ماست"] },
      safety: { title: "۹. ایمنی و مناسبت سنی", content: "اسباب‌بازی‌های ما برای کودکان ۳ سال به بالا طراحی شده. برخی طرح‌های جزئیات‌دار ممکن است قطعات کوچک داشته باشند." },
      account: { title: "۱۰. مسئولیت حساب کاربری", content: "شما مسئول حفظ محرمانگی حساب‌تان هستید. لطفاً رمز عبور قوی استفاده کنید." },
      liability: { title: "۱۱. محدودیت مسئولیت", content: "ما اسباب‌بازی می‌سازیم، نه معجزه. حداکثر مسئولیت ما محدود به مبلغی است که برای سفارش پرداخت کرده‌اید." },
      changes: { title: "۱۲. تغییرات در این شرایط", content: "ممکن است گاهی این شرایط را به‌روز کنیم. تغییرات مهم را از طریق ایمیل اطلاع می‌دهیم." },
      contact: { title: "۱۳. تماس با ما", intro: "سوال درباره این شرایط؟", items: ["ایمیل: legal@rubby.co.uk", "یا فرم تماس عادی ما را استفاده کنید"] },
    },
    footer: "ممنون که بخشی از خانواده روبی هستید. حالا برید جادو بسازید! ✨",
  },

  privacy: {
    badge: "حریم خصوصی شما مهم است",
    title: "سیاست حریم خصوصی",
    subtitle: "چگونه از داده‌های خانواده‌تان محافظت می‌کنیم (اسپویلر: جدی می‌گیریم!)",
    lastUpdated: "آخرین به‌روزرسانی",
    sections: {
      intro: { title: "۱. ما هم والد هستیم", content: "در روبی، خیلی از ما والد هستیم. اهمیت حفظ حریم خصوصی خانواده‌تان را می‌فهمیم." },
      collect: {
        title: "۲. چه جمع‌آوری می‌کنیم",
        provided: {
          title: "اطلاعاتی که ارائه می‌دهید:",
          account: { label: "اطلاعات حساب:", content: "نام، آدرس ایمیل، رمز عبور" },
          shipping: { label: "اطلاعات ارسال:", content: "آدرس، شماره تلفن (برای تحویل)" },
          payment: { label: "اطلاعات پرداخت:", content: "جزئیات پرداخت (امن از طریق زرین‌پال پردازش می‌شود)" },
          artwork: { label: "آثار شما:", content: "نقاشی‌ها و عکس‌هایی که آپلود می‌کنید" },
          communications: { label: "ارتباطات:", content: "پیام‌هایی که برایمان می‌فرستید" },
        },
        automatic: { title: "اطلاعاتی که خودکار جمع‌آوری می‌کنیم:", items: ["نوع دستگاه و مرورگر", "آدرس IP و موقعیت کلی", "نحوه استفاده از وب‌سایت", "کوکی‌ها برای ورود نگه داشتن"] },
      },
      use: { title: "۳. چگونه از اطلاعات استفاده می‌کنیم", items: { create: { label: "ساخت اسباب‌بازی:", content: "این دلیل اصلی است!" }, communicate: { label: "ارتباط با شما:", content: "به‌روزرسانی سفارش و پشتیبانی" }, improve: { label: "بهبود خدمات:", content: "فهمیدن نحوه استفاده خانواده‌ها از روبی" }, prevent: { label: "جلوگیری از تقلب:", content: "ایمن نگه داشتن همه" } } },
      artwork: { title: "۴. حریم خصوصی آثار شما", important: "این مهم است:", items: ["از آثار آپلود شده فقط برای ساخت سفارش شما استفاده می‌کنیم", "هرگز آثار را نمی‌فروشیم یا بدون اجازه برای آموزش هوش مصنوعی استفاده نمی‌کنیم", "اشتراک‌گذاری در گالری ۱۰۰٪ اختیاری است", "می‌توانید هر زمان درخواست حذف دهید"] },
      share: { title: "۵. با چه کسانی به اشتراک می‌گذاریم", intro: "داده‌هایتان را نمی‌فروشیم. فقط با این‌ها به اشتراک می‌گذاریم:", items: { payment: { label: "پردازشگر پرداخت (زرین‌پال):", content: "برای پردازش پرداخت" }, shipping: { label: "حمل‌کننده‌ها:", content: "آدرس ارسال برای تحویل" }, cloud: { label: "خدمات ابری:", content: "برای ذخیره امن داده‌ها" }, legal: { label: "الزامات قانونی:", content: "فقط در صورت الزام قانونی" } } },
      security: { title: "۶. امن نگه داشتن داده‌ها", intro: "از اقدامات امنیتی استاندارد صنعت استفاده می‌کنیم:", items: ["رمزنگاری SSL/TLS برای همه داده‌ها در انتقال", "ذخیره‌سازی رمزنگاری شده برای داده‌های حساس", "بررسی‌های امنیتی منظم", "دسترسی محدود کارکنان", "مراکز داده امن"] },
      children: { title: "۷. حریم خصوصی کودکان (COPPA)", content: "خدمات ما برای والدین/سرپرستان است. آگاهانه اطلاعات شخصی از کودکان زیر ۱۳ سال جمع‌آوری نمی‌کنیم." },
      rights: { title: "۸. حقوق شما", intro: "شما حق دارید:", items: { access: { label: "دسترسی:", content: "درخواست کپی داده‌هایتان" }, correct: { label: "اصلاح:", content: "به‌روز کردن اطلاعات نادرست" }, delete: { label: "حذف:", content: "درخواست حذف حساب" }, export: { label: "صادرات:", content: "دریافت داده‌ها در فرمت قابل حمل" }, optout: { label: "انصراف:", content: "لغو اشتراک از ایمیل‌های بازاریابی" } }, exercise: "برای استفاده از این حقوق به privacy@rubby.co.uk ایمیل بزنید. طبق UK-GDPR و EU-GDPR ظرف ۳۰ روز پاسخ می‌دهیم." },
      cookies: { title: "۹. کوکی‌ها", intro: "از کوکی‌ها استفاده می‌کنیم برای:", items: { essential: { label: "ضروری:", content: "ورود نگه داشتن" }, analytics: { label: "تحلیلی:", content: "فهم استفاده از سایت" }, preferences: { label: "ترجیحات:", content: "یادآوری تنظیماتتان" } }, disable: "می‌توانید کوکی‌ها را در مرورگر غیرفعال کنید." },
      international: { title: "۱۰. انتقال بین‌المللی", content: "روبی از بریتانیا اداره می‌شود. داده‌های شما در بریتانیا و اتحادیه اروپا تحت محافظت‌های UK-GDPR و EU-GDPR پردازش می‌شود. در مواردی که از پردازشگرهای فرعی خارج از بریتانیا/اتحادیه اروپا استفاده می‌کنیم (مثلاً ارائه‌دهندگان هوش مصنوعی یا زیرساخت ابری در آمریکا)، انتقال‌ها با Standard Contractual Clauses یا سازوکارهای تأییدشده معادل محافظت می‌شوند." },
      retention: { title: "۱۱. نگهداری داده‌ها", intro: "داده‌هایتان را نگه می‌داریم برای:", items: { account: { label: "داده حساب:", content: "تا وقتی حساب فعال است" }, orders: { label: "تاریخچه سفارش:", content: "۷ سال (برای اهداف قانونی/مالیاتی)" }, artwork: { label: "آثار آپلود شده:", content: "تا وقتی درخواست حذف دهید" }, analytics: { label: "داده تحلیلی:", content: "۲۶ ماه به صورت ناشناس" } } },
      changes: { title: "۱۲. تغییرات در این سیاست", content: "ممکن است گاهی این سیاست را به‌روز کنیم. تغییرات مهم را از طریق ایمیل اطلاع می‌دهیم." },
      contact: { title: "۱۳. سوالی دارید؟", intro: "اگر هر سوالی درباره نحوه رسیدگی به داده‌هایتان دارید:", items: ["ایمیل: privacy@rubby.co.uk", "یا از صفحه تماس ما استفاده کنید"] },
    },
    footer: "اعتماد شما همه چیز برای ماست. ممنون که به ما اجازه دادید بخشی از سفر خلاقانه خانواده‌تان باشیم. 💜",
  },

  account: {
    title: "حساب کاربری من",
    subtitle: "مدیریت پروفایل، سفارشات و پروژه‌ها",
    tabs: { profile: "پروفایل", kids: "فرزندان", shipping: "ارسال", orders: "سفارشات", projects: "پروژه‌ها" },
    profile: { 
      title: "جزئیات پروفایل", 
      description: "اطلاعات شخصی خود را به‌روز کنید",
      fullName: "نام کامل", 
      fullNamePlaceholder: "نام کامل خود را وارد کنید",
      firstName: "نام",
      firstNamePlaceholder: "نام خود را وارد کنید",
      lastName: "نام خانوادگی",
      lastNamePlaceholder: "نام خانوادگی خود را وارد کنید",
      email: "ایمیل", 
      emailDisabled: "ایمیل قابل تغییر نیست",
      phone: "شماره تلفن", 
      phonePlaceholder: "شماره تلفن خود را وارد کنید",
      noName: "نامی تنظیم نشده",
      save: "ذخیره پروفایل",
      dob: "تاریخ تولد",
      dobPlaceholder: "تاریخ تولد خود را انتخاب کنید",
      language: "زبان ترجیحی",
      languageEn: "انگلیسی (English)",
      languageFa: "فارسی",
    },
    kids: {
      title: "فرزندان من",
      description: "پروفایل فرزندانتان را برای تجربه شخصی‌سازی شده مدیریت کنید",
      addChild: "افزودن فرزند",
      editChild: "ویرایش",
      deleteChild: "حذف",
      empty: "هنوز فرزندی اضافه نشده",
      emptyDesc: "پروفایل فرزندانتان را اضافه کنید تا اسباب‌بازی‌ها و داستان‌ها را برایشان شخصی‌سازی کنیم!",
      firstName: "نام",
      firstNamePlaceholder: "نام فرزند",
      lastName: "نام خانوادگی",
      lastNamePlaceholder: "نام خانوادگی فرزند (اختیاری)",
      dob: "تاریخ تولد",
      dobPlaceholder: "تاریخ تولد را انتخاب کنید",
      gender: "جنسیت",
      genderBoy: "پسر",
      genderGirl: "دختر",
      genderOther: "دیگر",
      genderPreferNot: "ترجیح می‌دهم نگویم",
      interests: "علاقه‌مندی‌ها",
      interestsPlaceholder: "علاقه‌مندی‌ها را انتخاب کنید",
      avatarEmoji: "یک ایموجی انتخاب کنید",
      save: "ذخیره فرزند",
      cancel: "انصراف",
      confirmDelete: "آیا مطمئنید که می‌خواهید پروفایل این فرزند را حذف کنید؟",
      childSaved: "پروفایل فرزند ذخیره شد!",
      childDeleted: "پروفایل فرزند حذف شد",
      childError: "ذخیره پروفایل فرزند ناموفق بود",
      deleteError: "حذف پروفایل فرزند ناموفق بود",
      age: "{years} ساله",
      interestOptions: {
        animals: "حیوانات",
        dinosaurs: "دایناسورها",
        space: "فضا",
        princesses: "شاهزاده‌ها",
        superheroes: "ابرقهرمانان",
        cars: "ماشین‌ها",
        art: "هنر",
        music: "موسیقی",
        sports: "ورزش",
        science: "علوم",
      },
    },
    shipping: { 
      title: "آدرس پیش‌فرض ارسال", 
      description: "این آدرس در پرداخت از پیش پر می‌شود",
      address: "آدرس خیابان", 
      addressPlaceholder: "خیابان اصلی پلاک ۱۲۳",
      city: "شهر", 
      cityPlaceholder: "شهر",
      state: "استان", 
      statePlaceholder: "استان",
      postalCode: "کد پستی", 
      postalCodePlaceholder: "۱۲۳۴۵",
      country: "کشور", 
      countryPlaceholder: "کشور",
      save: "ذخیره آدرس" 
    },
    orders: { 
      title: "سفارشات من", 
      description: "پیگیری سفارشات اسباب‌بازی و ارسال‌ها",
      empty: "هنوز سفارشی ندارید", 
      emptyDesc: "سفارشات شما پس از تکمیل خرید اینجا نمایش داده می‌شود",
      startCreating: "شروع خلق",
      tracking: "پیگیری",
      status: "وضعیت", 
      date: "تاریخ سفارش", 
      viewDetails: "مشاهده جزئیات",
      reorder: "سفارش مجدد",
      reorderBanner: "در حال ساخت دوباره سفارش قبلی. مشخصات قبلی بارگذاری شده‌اند."
    },
    projects: { 
      title: "پروژه‌های من", 
      description: "مشاهده و ادامه کار روی طراحی‌های اسباب‌بازی",
      empty: "هنوز پروژه‌ای ندارید", 
      emptyDesc: "اولین اسباب‌بازی سفارشی خود را بسازید",
      createToy: "ساخت اسباب‌بازی",
      newProject: "پروژه جدید", 
      continue: "برای ادامه کلیک کنید ←", 
      status: "وضعیت",
      drawingToToy: "نقاشی به اسباب‌بازی",
      photoToToy: "عکس به اسباب‌بازی",
      drawingToStory: "نقاشی به داستان",
      newDrawingToy: "نقاشی جدید",
      newPhotoToy: "عکس جدید",
      newStorybook: "داستان جدید",
      emptyDrawings: "هنوز پروژه نقاشی ندارید",
      emptyPhotos: "هنوز پروژه عکس ندارید",
      emptyStorybooks: "هنوز کتاب داستانی ندارید",
      toy: "اسباب‌بازی",
      story: "داستان",
      animation: "انیمیشن",
      game: "بازی",
      custom: "سفارشی",
      newToy: "اسباب‌بازی جدید",
      newAnimation: "انیمیشن جدید",
      emptyToys: "هنوز پروژه اسباب‌بازی ندارید",
      emptyAnimations: "هنوز پروژه انیمیشنی ندارید",
      emptyCustom: "هنوز پروژه سرویس سفارشی ندارید",
      gameComingSoon: "بازی‌ها به‌زودی اضافه می‌شوند",
    },
    toasts: {
      profileUpdated: "پروفایل با موفقیت به‌روز شد",
      profileError: "ذخیره پروفایل ناموفق بود",
      addressSaved: "آدرس ارسال ذخیره شد",
      addressError: "ذخیره آدرس ناموفق بود",
      loadProfileError: "بارگذاری پروفایل ناموفق بود",
      loadOrdersError: "بارگذاری سفارشات ناموفق بود",
      loadProjectsError: "بارگذاری پروژه‌ها ناموفق بود"
    }
  },

  wizard: {
    // Page header
    pageTitle: "اسباب‌بازی خود را بسازید",
    pageSubtitle: "این مراحل را دنبال کنید تا نقاشی خود را به یک اسباب‌بازی سه‌بعدی شگفت‌انگیز تبدیل کنید",
    pageSubtitlePhoto: "این مراحل را دنبال کنید تا عکس خود را به یک فیگور سه‌بعدی شگفت‌انگیز تبدیل کنید",
    progress: "پیشرفت",
    stepOf: "مرحله {current} از {total}",
    stepsTitle: "مراحل",
    
    // Step names
    steps: { 
      upload: "به ریکو نشون بده", 
      uploadDesc: "یک نقاشی یا عکس آپلود کن تا ریکو جادوش کنه",
      preview: "جادو", 
      previewDesc: "ببین ریکو چطور تبدیلش می‌کنه به یک شخصیت",
      rotation: "دور تا دور",
      rotationDesc: "شخصیتت رو از هر زاویه ببین",
      model: "سه‌بعدی", 
      modelDesc: "ساخته‌ات رو سه‌بعدی ببین، بعد انتخاب کن چی می‌خوای",
      specs: "دلخواه خودت", 
      specsDesc: "اندازه، جنس و رنگ رو انتخاب کن",
      checkout: "پرداخت", 
      checkoutDesc: "تأیید و پرداخت",
      confirmation: "هورا!",
      confirmationDesc: "ساخته‌ات آماده‌ی اشتراک‌گذاریه"
    },
    
    // New Project Dialog
    newProject: {
      button: "پروژه جدید",
      title: "شروع پروژه جدید؟",
      description: "پروژه فعلی ذخیره می‌شود و می‌توانید بعداً از صفحه حساب کاربری ادامه دهید.",
      cancel: "لغو",
      confirm: "شروع پروژه جدید"
    },

    leave: {
      title: "خارج شوید؟",
      description: "پیشرفت شما ذخیره خواهد شد. می‌توانید بعداً ادامه دهید.",
      stay: "ادامه",
      leave: "خروج",
    },
    
    // Order locked banner
    orderLocked: {
      title: "سفارش تأیید شد",
      description: "این سفارش تأیید شده است. تنظیمات قابل تغییر نیستند."
    },

    recovery: {
      title: "به نظر می‌رسد این مرحله گیر کرده",
      titleFailed: "این مرحله ناموفق بود",
      body: "می‌توانید اینجا دوباره تلاش کنید، یا به مرحله بعد بروید تا ما تولید را دوباره شروع کنیم.",
      retry: "تلاش دوباره",
      goNext: "مرحله بعد",
      continuing: "در حال ادامه…",
      waitingPrevious: "تولید مرحله قبل هنوز در حال اجراست…",
      alreadyRunning: "تولید از قبل در حال اجراست",
    },

    catalog: {
      loading: "در حال بارگذاری قیمت‌ها…",
      errorTitle: "بارگذاری قیمت‌ها ناموفق بود",
      errorBody: "قیمت‌گذاری هنوز در دسترس نیست. برای ادامه دوباره تلاش کنید.",
      retry: "تلاش مجدد",
      notReady: "قیمت‌ها هنوز آماده نیستند. لطفاً صبر کنید یا دوباره تلاش کنید.",
    },
    
    // Step 0: Upload
    upload: { 
      title: "بیایید جادو بسازیم!",
      subtitleDrawing: "یک سبک انتخاب کنید، نقاشی را آپلود کنید و نامی برایش بگذارید",
      subtitlePhoto: "یک سبک انتخاب کنید، عکس را آپلود کنید و نامی برایش بگذارید",
      chooseStyle: "سبک را انتخاب کنید",
      toyName: "نامی برای اثرتان بگذارید",
      toyNamePlaceholder: "نامی ماندگار برای اسباب‌بازی...",
      toyNameError: "نام اسباب‌بازی باید حداقل ۳ کاراکتر باشد",
      toyNameErrorMax: "نام اسباب‌بازی باید کمتر از ۵۰ کاراکتر باشد",
      toyNameErrorFormat: "فقط حروف، اعداد، فاصله، خط تیره و زیرخط مجاز است",
      uploadTitle: "تصویر را آپلود کنید",
      analysing: "در حال تحلیل تصویر…",
      analyseFailed: "تحلیل تصویر ممکن نشد. دوباره تلاش کنید.",
      pickCharacterTitle: "یک شخصیت انتخاب کنید",
      pickCharacterHint: "این شخصیت‌ها را پیدا کردیم. یکی را انتخاب کنید تا به اسباب‌بازی تبدیل شود.",
      pickCharacterHintStory:
        "این شخصیت‌ها را پیدا کردیم. هر کدام را که می‌خواهید در داستان باشند انتخاب کنید.",
      pickCharacterHintAnimation:
        "این شخصیت‌ها را پیدا کردیم. هر کدام را که می‌خواهید در انیمیشن باشند انتخاب کنید.",
      nameYourCharacter: "اسم شخصیت",
      confirmCharacter: "همین شخصیت",
      noCharactersFound: "شخصیتی پیدا نشد. تصویر دیگری امتحان کنید.",
      drawingOrPhoto: "این یک نقاشی است یا عکس؟",
      styleTips: "نکات برای سبک بهتر",
      styleTipsTitle: "نکات سبک",
      styleTip1: "از عکس واضح با نور مناسب استفاده کنید.",
      styleTip2: "صورت و ویژگی‌ها بهتر دیده شوند.",
      styleTip3: "پس‌زمینه شلوغ نباشد.",
      styleTip4: "برای نتیجه طبیعی، سبک کارتونی انتخاب کنید.",
      smartRecs: "پیشنهادات هوشمند اعمال شد",
      pickStyleConfirm: "یک سبک انتخاب کنید و برای هر تصویر بارگذاری‌شده یک شخصیت تأیید کنید.",
      uploadThenAnalyse: "یک یا چند تصویر بارگذاری کنید و برای هر کدام روی تحلیل بزنید.",
      animationStyle: "سبک انیمیشن",
      styles: { 
        cartoon: "کارتونی", 
        realistic: "واقع‌گرایانه", 
        anime: "انیمه", 
        lego: "لگو", 
        actionFigure: "فیگور اکشن",
        pixar: "پیکسار سه‌بعدی",
        funko: "فانکو پاپ",
        chibi: "چیبی فیگورین",
        vinyl: "وینیل تویز"
      }
    },
    
    // Step 1: Magic Preview
    preview: { 
      title: "پیش‌نمایش کاراکتر هوش مصنوعی",
      originalLabel: "اصلی",
      resultLabel: "کاراکتر تولید شده",
      characterReady: "کاراکتر دوبعدی شما آماده است!",
      characterSuccess: "کاراکتر با موفقیت ساخته شد! برای ساخت مدل سه‌بعدی روی بعدی کلیک کنید.",
      generating: "در حال تولید...",
      generatingDefault: "در حال تولید کاراکتر...",
      pleaseWait: "ممکن است چند دقیقه طول بکشد. لطفاً صبر کنید...",
      requestEdit: "ویرایش",
      processing: "در حال پردازش...",
      editingOverlay: "در حال ویرایش…",
      editLabel: "تغییرات مورد نظر را توضیح دهید",
      editPlaceholder: "مثال: چشم‌ها را بزرگ‌تر کن، رنگ مو را آبی کن، لبخند اضافه کن...",
      editMinLength: "لطفاً تغییرات را توضیح دهید (حداقل ۱۰ کاراکتر)",
      editMaxLength: "توضیحات باید کمتر از ۵۰۰ کاراکتر باشد",
      processEdit: "ارسال ویرایش",
      regenerate: "بازسازی",
      retryLoading: "تلاش مجدد بارگذاری تصویر",
      versionsTitle: "نسخه‌های قبلی",
      versionsEmpty: "هنوز نسخه‌ای ذخیره نشده",
      versionBase: "نسخه اولیه",
      versionLabel: "نسخه {n}",
      versionActive: "انتخاب‌شده",
      versionSelect: "استفاده از این نسخه",
      revert: "بازگشت به نسخه قبل",
      regenerateUnavailable: "تا وقتی پروژه ساخته نشود، بازسازی در دسترس نیست.",
    },
    
    // Step 2: 180° View
    rotation: {
      title: "نمای ۱۸۰° کاراکتر",
      subtitle: "نمای پشت کاراکتر تولید شده با هوش مصنوعی برای کیفیت بهتر سه‌بعدی",
      generating: "در حال تولید نمای ۱۸۰°...",
      generatingDesc: "در حال ساخت نمای پشت کاراکتر شما...",
      confirmingDesc: "در حال آماده‌سازی تصویر چرخشی...",
      ready: "نمای ۱۸۰° آماده است!",
      readyDesc: "تأیید یا بازسازی نمای پشت قبل از ادامه به تولید سه‌بعدی.",
      frontView: "نمای جلو",
      backView: "نمای پشت",
      frontLabel: "نمای جلو",
      backLabel: "نمای پشت (تولید شده)",
      regenerate: "بازسازی",
      confirm: "تأیید و ادامه",
      failed: "تولید نمای ۱۸۰° ناموفق بود. لطفاً دوباره تلاش کنید.",
      failedDesc: "لطفاً دوباره تلاش کنید.",
      bgRemovalFailed: "حذف پس‌زمینه تصویر چرخشی ناموفق بود. می‌توانید بازسازی یا دوباره تلاش کنید.",
      retry: "تلاش مجدد",
      imageUnavailable: "این شیت مرجع بارگذاری نشد. صفحه را دوباره باز کن یا شیت را بازسازی کن."
    },
    
    // Step 2: 3D Model
    model: { 
      title: "مدل سه‌بعدی هوش مصنوعی",
      modelReady: "مدل سه‌بعدی شما آماده است!",
      modelSuccess: "مدل سه‌بعدی با موفقیت ساخته شد! می‌توانید به مرحله بعد بروید.",
      waitingForUrl: "در انتظار آدرس مدل سه‌بعدی...",
      manualUpload: "مدل سه‌بعدی آماده است - لطفاً دستی به دیتابیس آپلود کنید",
      generating: "در حال تولید مدل سه‌بعدی...",
      processingToy: "در حال پردازش \"{name}\"...",
      processingDefault: "در حال پردازش...",
      creatingModel: "در حال ساخت مدل سه‌بعدی (~۹۰ ثانیه)...",
      format: "فرمت",
      readyForProduction: "آماده تولید"
    },
    
    // Step 3: Specs
    specs: { 
      title: "مشخصات تولید",
      subtitle: "مشخصات سفارشی اسباب‌بازی را برای تولید پیکربندی کنید",
      basePrice: "۹٬۹۸۰٬۰۰۰ ریال",
      size: { 
        title: "اندازه",
        small: "کوچک (۱۰ سانتی‌متر)",
        smallDesc: "عالی برای نمایش روی میز",
        medium: "متوسط (۱۵ سانتی‌متر)",
        mediumDesc: "محبوب‌ترین اندازه",
        large: "بزرگ (۲۰ سانتی‌متر)",
        largeDesc: "عالی برای هدیه",
        veryLarge: "خیلی بزرگ (۲۵ سانتی‌متر)",
        veryLargeDesc: "قطعه نمایشی ممتاز"
      }, 
      material: { 
        title: "جنس",
        pla: "PLA استاندارد",
        plaDesc: "پلاستیک بادوام و دوست‌دار محیط زیست",
        petg: "PETG مقاوم",
        petgDesc: "فوق‌العاده محکم و مقاوم در برابر ضربه",
        tpu: "TPU انعطاف‌پذیر",
        tpuDesc: "مواد نرم و قابل خم شدن",
        resin: "رزین جزئیات بالا",
        resinDesc: "جزئیات فوق‌العاده و سطح صاف"
      }, 
      color: { 
        title: "طرح رنگ",
        single: "تک‌رنگ",
        singleDesc: "یک رنگ یکدست",
        full: "رنگ کامل",
        fullDesc: "پرینت چند رنگ"
      },
      totalPrice: "قیمت کل:",
      priceIncludes: "شامل تولید، مواد و ارسال رایگان در ایران"
    },
    
    // Step 4: Checkout
    checkout: { 
      title: "پرداخت",
      subtitle: "سفارش و پرداخت را تکمیل کنید",
      orderSummary: "خلاصه سفارش",
      basePrice: "قیمت پایه (اسباب‌بازی سه‌بعدی)",
      size: "اندازه",
      material: "جنس",
      colorPlan: "طرح رنگ",
      total: "مجموع",
      prototypeMode: "حالت نمونه اولیه",
      prototypeDesc: "این یک نمایش است. پرداخت واقعی انجام نمی‌شود.",
      payButton: "ادامه با پرداخت آزمایشی",
      payButtonProcessing: "در حال پردازش...",
      prototypeNote: "حالت نمونه - سفارش بدون پرداخت واقعی تأیید می‌شود",
      lockedTotal: "مبلغ قفل‌شده برای سفارش:",
      missingQuote: "قبل از پرداخت باید قیمت قفل شود. به مرحله قبل برگردید و ادامه دهید.",
    },
    
    // Step 5: Confirmation
    confirmation: { 
      title: "سفارش تأیید شد!",
      subtitle: "اکنون در حال تولید است",
      orderNumber: "سفارش #",
      trackOrder: "پیگیری سفارش",
      viewModel: "مشاهده مدل سه‌بعدی"
    },

    // Fulfillment chooser on the "In 3D" step
    fulfillment: {
      title: "چطور می‌خوای تحویلش بگیری؟",
      subtitle: "انتخاب کن چی می‌خوای امروز ببری خونه",
      required: "برای ادامه یکی را انتخاب کن",
      payModel: "پرداخت {price} برای مدل سه‌بعدی دیجیتال",
      downloadModel: "دانلود مدل سه‌بعدی (.glb)",
      downloadWebModel: "دانلود نسخه وب (.glb)",
      modelPreparing: "مدل شما در حال آماده‌سازی است — کمی بعد دوباره بررسی کنید",
      options: {
        model: {
          title: "مدل سه‌بعدی",
          desc: "دانلود فوری .glb — خودت چاپ کن یا در بازی استفاده کن"
        },
        toy: {
          title: "اسباب‌بازی فیزیکی",
          desc: "ما چاپ، رنگ و برایت ارسال می‌کنیم"
        },
        both: {
          title: "هر دو",
          desc: "مدل دیجیتال + اسباب‌بازی فیزیکی"
        }
      },
      checkoutHint: {
        model: "مدل سه‌بعدی دیجیتال — دانلود فوری پس از پرداخت",
        toy: "اسباب‌بازی فیزیکی — چاپ و ارسال به درب منزل",
        both: "اسباب‌بازی فیزیکی + دانلود مدل سه‌بعدی"
      },
      confirmationSubtitle: {
        model: "آماده دانلود است",
        toy: "اکنون در حال تولید است",
        both: "آماده دانلود است و در حال تولید"
      }
    },

    
    // Navigation
    nav: {
      back: "قبلی",
      next: "بعدی",
      finish: "پایان",
      creatingProject: "در حال ایجاد پروژه...",
      starting3D: "شروع تولید سه‌بعدی...",
      processingEdit: "پردازش ویرایش...",
      backToHooray: "بازگشت به هورا!"
    },
    
    // Toasts
    toasts: {
      fileUploaded: "فایل با موفقیت آپلود شد",
      fileUploadedDesc: "{fileName} آماده پردازش است.",
      startingFresh: "شروع از نو",
      startingFreshDesc: "تصویر جدید آپلود شد. پیشرفت قبلی ریست شد.",
      specsUpdated: "مشخصات به‌روزرسانی شد",
      specsUpdatedDesc: "قیمت مجدداً محاسبه شد.",
      specsSaved: "مشخصات ذخیره شد!",
      specsSavedDesc: "مشخصات اسباب‌بازی تأیید شد.",
      specsErrorDesc: "ذخیره مشخصات ناموفق بود. لطفاً دوباره تلاش کنید.",
      validationFailed: "اعتبارسنجی ناموفق",
      validationFailedDesc: "لطفاً ورودی‌ها را بررسی کنید.",
      imageRequired: "تصویر الزامی است",
      uploadImageRequired: "برای ادامه یک نقاشی یا عکس آپلود کنید.",
      uploadDrawingRequired: "لطفاً یک نقاشی آپلود کنید.",
      uploadPhotoRequired: "لطفاً یک عکس آپلود کنید.",
      authRequired: "احراز هویت الزامی است",
      authRequiredDesc: "برای ادامه وارد شوید.",
      changesDetected: "تغییرات شناسایی شد",
      changesDetectedDesc: "کاراکتر با تنظیمات جدید بازسازی می‌شود...",
      projectCreated: "پروژه ایجاد شد!",
      generatingCharacter: "در حال تولید کاراکتر شما...",
      generatingFigure: "در حال تولید فیگور شما...",
      errorCreatingProject: "خطا در ایجاد پروژه",
      errorCreatingProjectDesc: "ذخیره پروژه ناموفق بود. لطفاً دوباره تلاش کنید.",
      errorUpdatingProject: "خطا در به‌روزرسانی پروژه",
      errorUpdatingProjectDesc: "به‌روزرسانی پروژه ناموفق بود. لطفاً دوباره تلاش کنید.",
      creatingNewVersion: "ایجاد نسخه جدید",
      creatingNewVersionDesc: "ویرایش جدید درخواست شد. مدل سه‌بعدی بازسازی می‌شود.",
      processingChanges: "پردازش تغییرات...",
      processingChangesDesc: "هوش مصنوعی در حال ویرایش کاراکتر دوبعدی است.",
      changesApplied: "تغییرات اعمال شد!",
      changesAppliedDesc: "کاراکتر دوبعدی با موفقیت به‌روزرسانی شد.",
      editErrorDesc: "پردازش تغییرات ناموفق بود. لطفاً دوباره تلاش کنید.",
      preparingImage: "آماده‌سازی تصویر",
      preparingImageDesc: "در حال حذف پس‌زمینه...",
      backgroundRemoved: "پس‌زمینه حذف شد",
      backgroundRemovedDesc: "شروع تولید مدل سه‌بعدی...",
      generationStarted: "تولید سه‌بعدی شروع شد",
      generationStartedDesc: "در حال ساخت مدل (~۹۰ ثانیه)...",
      generationFailed: "تولید ناموفق بود",
      generationFailedDesc: "تولید مدل سه‌بعدی ناموفق بود. لطفاً دوباره تلاش کنید.",
      modelGenerated: "مدل سه‌بعدی ساخته شد!",
      modelGeneratedDesc: "مدل سه‌بعدی شما آماده است.",
      characterGenerated: "کاراکتر ساخته شد!",
      characterGeneratedDesc: "کاراکتر دوبعدی شما آماده است.",
      paymentComplete: "پرداخت آزمایشی کامل شد! 🎉",
      paymentCompleteDesc: "سفارش آزمایشی #{orderNumber} ایجاد شد. این یک نمونه است - پرداخت واقعی انجام نشد.",
      checkoutErrorDesc: "تکمیل پرداخت آزمایشی ناموفق بود.",
      orderConfirmed: "سفارش تأیید شد",
      orderConfirmedDesc: "سفارش تأیید شده است. تنظیمات قابل تغییر نیستند.",
      generationError: "خطای تولید",
      generationErrorDesc: "تولید کاراکتر ناموفق بود. لطفاً دوباره تلاش کنید.",
      error: "خطا",
      noProjectError: "پروژه‌ای یافت نشد. لطفاً از نو شروع کنید.",
      projectNotFoundError: "اطلاعات پروژه یا کاربر یافت نشد.",
      pleaseWait: "لطفاً کمی صبر کنید…",
      checkingSignIn: "در حال بررسی وضعیت ورود هستیم.",
      noCharactersTryAgain: "کاراکتری پیدا نشد. تصویر دیگری امتحان کن یا دستی اسم بگذار.",
      analysisReady: "تحلیل آماده است",
      analysisReadyDesc: "کاراکتر را انتخاب و تأیید کن، بعد با «بعدی» برو صفحه جادو برای ساخت تصویر.",
      nameTooShort: "لطفاً یک اسم برای ساخته‌ات بذار (حداقل ۳ حرف)",
      versionSelected: "نسخه فعال شد",
      versionModelLoaded: "مدل سه‌بعدی این نسخه از حافظه بارگذاری شد.",
      versionSheetActive: "این نسخه شیت مرجع فعال شد. مدل سه‌بعدی باید از نو ساخته شود.",
      versionSheetLoaded: "شیت مرجع این نسخه از حافظه بارگذاری شد.",
      versionContinueSheet: "نسخه انتخاب شد. با ادامه، شیت مرجع از نو ساخته می‌شود.",
      editApplied: "ویرایش اعمال شد.",
      reverted: "بازگشت انجام شد",
      revertedWithSheet: "نسخه قبلی و شیت مربوط به آن بارگذاری شد.",
      revertedContinueSheet: "نسخه قبلی فعال شد. با ادامه، شیت از نو ساخته می‌شود.",
      viewsEditApplied: "ویرایش نماها اعمال شد.",
      styleChangeConfirm: "تغییر استایل باعث می‌شود کاراکتر، شیت مرجع و مدل ۳بعدی فعلی حذف شود و باید دوباره ساخته شود. ادامه می‌دهی؟",
      rerunMagic: "دوباره Magic Preview را اجرا کن",
      styleChanged: "استایل عوض شد — برای ساخت دوباره کاراکتر، روی تحلیل بزن.",
      renameConfirm: "تغییر اسم باعث می‌شود شیت مرجع و مدل ۳بعدی فعلی حذف شود و باید دوباره ساخته شود. ادامه می‌دهی؟",
      welcomeBackProgress: "خوش برگشتی!",
      welcomeBackProgressDesc: "پیشرفتت ذخیره شده. الان مرحله {current} از {total} هستی.",
      couldNotCreateProject: "نتوانستیم پروژه را بسازیم. لطفاً دوباره تلاش کنید.",
      rerunAnalyse: "لطفاً قبل از تأیید کاراکتر دوباره تحلیل را اجرا کنید.",
      analysisInProgress: "لطفاً صبر کنید — تحلیل هنوز در جریان است.",
      analyseAndPick: "لطفاً تصویر را تحلیل کنید و قبل از ادامه یک کاراکتر انتخاب کنید.",
      pickAndConfirmName: "لطفاً یک کاراکتر انتخاب کنید و نام را تأیید کنید.",
      runAnalyseFirst: "لطفاً ابتدا تصویر را تحلیل کنید.",
      toyNameMin: "نام اسباب‌بازی باید حداقل ۳ کاراکتر باشد",
      toyNameMax: "نام اسباب‌بازی باید کمتر از ۵۰ کاراکتر باشد",
      toyNameChars: "فقط حروف، اعداد، فاصله، خط تیره و زیرخط مجاز است",
    },
  },
  
  // File upload components
  fileUpload: {
    dropzone: {
      dropPhoto: "عکس‌شان را اینجا رها کنید",
      dropArtwork: "شاهکارشان را اینجا رها کنید",
      dropImage: "نقاشی یا عکس‌شان را اینجا رها کنید",
      orClick: "یا برای مرور کلیک کنید",
      supportedFormats: "فرمت‌های پشتیبانی: PNG، JPG، JPEG، WebP، AVIF، GIF، HEIC",
      maxSize: "حداکثر حجم فایل: ۲۰ مگابایت",
      invalidType: "نوع فایل نامعتبر",
      onlyAllowed: "فقط فایل‌های PNG، JPG، JPEG، WebP، AVIF، GIF و HEIC مجاز هستند",
      dropHere: "تصویر را اینجا رها کنید!",
      fileTooLarge: "فایل خیلی بزرگ است ({size} مگابایت). حداکثر حجم {max} مگابایت است.",
      couldNotRead: "این تصویر خوانده نشد. لطفاً عکس دیگری امتحان کنید.",
      uploading: "در حال آپلود...",
      choosePhotoGallery: "انتخاب عکس از گالری",
      chooseDrawingGallery: "انتخاب نقاشی از گالری",
      chooseImageGallery: "انتخاب تصویر",
      takePhoto: "گرفتن عکس",
      tipsPhoto: "نکات برای عکس بهتر",
      tipsUpload: "نکات برای عکس بهتر",
      tipsTitle: "نکات آپلود",
      tipPhoto1: "نور خوب — در نزدیکی پنجره عکس بگیرید",
      tipPhoto2: "پس‌زمینه ساده",
      tipPhoto3: "فقط یک نفر در کادر باشد",
      tipPhoto4: "از نزدیک عکس بگیرید",
      tipUpload1: "نقاشی را روی سطح صاف بگذارید",
      tipUpload2: "نور یکنواخت — بدون سایه",
      tipUpload3: "کل نقاشی در کادر باشد",
      tipUpload4: "از زاویه مستقیم عکس بگیرید",
    },
    preview: {
      uploadedImage: "تصویر آپلود شده",
      previouslyUploaded: "تصویر قبلاً آپلود شده",
      replace: "جایگزینی",
      analyse: "تحلیل",
      reanalyse: "تحلیل دوباره",
      addCharacter: "افزودن کاراکتر",
      characterAdded: "افزوده شد",
      characterConfirmed: "«{name}» انتخاب شد و همین کاراکتر اسباب‌بازی می‌شود.",
      characterConfirmedStory: "«{name}» به شخصیت‌های داستان اضافه شد.",
      characterConfirmedAnimation: "«{name}» به شخصیت‌های انیمیشن اضافه شد.",
      addCharacters: "افزودن {count} شخصیت",
      charactersAdded: "افزوده شد",
      drawingLabel: "نقاشی",
      generatedPhoto: "عکس تولیدشده",
      googleDrive: "گوگل درایو",
      local: "محلی",
      drawing: "نقاشی",
      photo: "عکس",
      typeQuestion: "این یک"
    }
  },

  auth: {
    brand: "روبی",
    tagline: "طرح‌های خود را به اسباب‌بازی جادویی تبدیل کنید",
    signIn: { 
      title: "خوش برگشتید", 
      subtitle: "برای ادامه ساخت اسباب‌بازی‌های شگفت‌انگیز وارد شوید",
      button: "ورود",
      buttonLoading: "در حال ورود...",
      noAccount: "حساب ندارید؟",
      createOne: "همین الان بسازید",
      tabPassword: "رمز عبور",
      tabOtp: "کد یک‌بارمصرف"
    },
    otp: {
      title: "ورود با کد",
      subtitle: "کد تأیید را با ایمیل یا پیامک دریافت کنید",
      channelEmail: "ایمیل",
      channelSms: "پیامک",
      phone: "شماره موبایل",
      phonePlaceholder: "09123456789",
      code: "کد تأیید",
      codePlaceholder: "۶ رقم",
      sendCode: "ارسال کد",
      sendCodeLoading: "در حال ارسال...",
      verify: "تأیید و ورود",
      verifyLoading: "در حال تأیید...",
      resend: "ارسال مجدد کد",
      changeDestination: "تغییر ایمیل / شماره",
      codeSent: "کد ارسال شد",
      codeSentDesc: "کد تأیید را وارد کنید.",
      codeSentDev: "کد توسعه",
      invalidPhone: "شماره موبایل معتبر نیست (مثال: ۰۹۱۲۳۴۵۶۷۸۹)",
      invalidCode: "کد باید ۶ رقم باشد",
      cooldown: "لطفاً کمی صبر کنید و دوباره تلاش کنید"
    },
    signUp: { 
      title: "ایجاد حساب", 
      subtitle: "سفر خلاقانه خود را با روبی شروع کنید",
      button: "ارسال کد تأیید",
      buttonLoading: "در حال ارسال کد...",
      hasAccount: "قبلاً حساب دارید؟",
      signInInstead: "به جای آن وارد شوید",
      checkSpam: "ایمیل دریافت نکردید؟ پوشه اسپم خود را بررسی کنید یا دوباره تلاش کنید.",
      backToSignIn: "بازگشت به ورود",
      verifyTitle: "تأیید ایمیل",
      verifySubtitle: "کد ۶ رقمی ارسال‌شده به ایمیل را وارد کنید"
    },
    forgotPassword: { 
      title: "بازیابی رمز عبور", 
      subtitle: "ایمیل خود را برای دریافت لینک بازیابی وارد کنید",
      button: "ارسال لینک بازیابی",
      buttonLoading: "در حال ارسال لینک...",
      remember: "رمز عبور خود را به یاد دارید؟",
      backToSignIn: "بازگشت به ورود"
    },
    resetPassword: {
      title: "تنظیم رمز عبور جدید",
      subtitle: "یک رمز عبور قوی برای حساب خود انتخاب کنید",
      button: "به‌روزرسانی رمز عبور",
      buttonLoading: "در حال به‌روزرسانی..."
    },
    fields: {
      email: "ایمیل",
      emailPlaceholder: "ایمیل خود را وارد کنید",
      password: "رمز عبور",
      passwordPlaceholder: "رمز عبور خود را وارد کنید",
      confirmPassword: "تأیید رمز عبور",
      confirmPasswordPlaceholder: "رمز عبور را تأیید کنید"
    },
    passwordStrength: {
      label: "قدرت رمز عبور:",
      veryWeak: "خیلی ضعیف",
      weak: "ضعیف",
      fair: "متوسط",
      good: "خوب",
      strong: "قوی",
      minRequired: "قدرت رمز عبور باید حداقل «متوسط» باشد."
    },
    validation: {
      emailRequired: "لطفاً یک آدرس ایمیل معتبر وارد کنید",
      passwordMin: "رمز عبور باید حداقل ۶ کاراکتر باشد",
      passwordsNoMatch: "رمزهای عبور مطابقت ندارند",
      passwordTooWeak: "رمز عبور خیلی ضعیف است",
      passwordTooWeakDesc: "لطفاً رمز عبور قوی‌تری انتخاب کنید (حداقل: متوسط)."
    },
    errors: {
      generic: "خطایی رخ داد",
      invalidCredentials: "ایمیل یا رمز عبور نامعتبر",
      userExists: "حسابی با این ایمیل از قبل وجود دارد",
      emailNotConfirmed: "لطفاً ایمیل خود را بررسی کنید و روی لینک تأیید کلیک کنید",
      accountBanned: "این حساب مسدود شده است.",
      accountSuspended: "این حساب موقتاً تعلیق شده است.",
      unexpected: "خطای غیرمنتظره‌ای رخ داد. لطفاً دوباره امتحان کنید."
    },
    toasts: {
      resetEmailSent: "ایمیل بازیابی ارسال شد",
      resetEmailSentDesc: "ایمیل خود را برای لینک بازیابی بررسی کنید.",
      resetEmailError: "ارسال ایمیل بازیابی ناموفق بود.",
      passwordUpdated: "رمز عبور به‌روز شد",
      passwordUpdatedDesc: "رمز عبور شما با موفقیت بازنشانی شد.",
      passwordUpdateError: "به‌روزرسانی رمز عبور ناموفق بود.",
      accountCreated: "کد ارسال شد",
      accountCreatedDesc: "کد تأیید را از ایمیل خود وارد کنید تا حساب ساخته شود.",
      welcomeBack: "خوش برگشتید!",
      welcomeBackDesc: "با موفقیت وارد شدید.",
      authError: "خطای احراز هویت",
      emailRequired: "ایمیل الزامی است",
      emailRequiredDesc: "لطفاً آدرس ایمیل خود را وارد کنید."
    },
    footer: {
      terms: "با ادامه دادن، شما موافقت می‌کنید با",
      termsLink: "شرایط خدمات",
      and: "و",
      privacyLink: "سیاست حفظ حریم خصوصی"
    },
    separator: "یا"
  },

  orderTracking: {
    title: "پیگیری سفارش",
    subtitle: "کد پیگیری خود را برای مشاهده وضعیت اسباب‌بازی سفارشی وارد کنید",
    searchPlaceholder: "کد پیگیری را وارد کنید (مثال: DT2024-ABC123)",
    searchButton: "پیگیری سفارش",
    searching: "در حال جستجو...",
    orderNumber: "سفارش",
    tracking: "پیگیری",
    customer: "مشتری",
    deliveryAddress: "آدرس تحویل",
    estimatedDelivery: "تاریخ تخمینی تحویل",
    productionProgress: "پیشرفت تولید",
    started: "شروع شده",
    complete: "تکمیل",
    delivered: "تحویل داده شده",
    inProgress: "در حال انجام",
    yourToy: "اسباب‌بازی سفارشی شما",
    modelPreview: "پیش‌نمایش مدل سه‌بعدی",
    toyDescription: "اسباب‌بازی سفارشی شما بر اساس نقاشی آپلود شده",
    viewAR: "مشاهده در AR",
    statuses: {
      received: "دریافت شد",
      printing: "در حال چاپ",
      postProcessing: "پردازش",
      painting: "رنگ‌آمیزی",
      qa: "بررسی کیفیت",
      packed: "بسته‌بندی شد",
      shipped: "ارسال شد"
    }
  },

  toast: {
    success: { saved: "تغییرات با موفقیت ذخیره شد", uploaded: "فایل با موفقیت آپلود شد", orderPlaced: "سفارش با موفقیت ثبت شد", copied: "در کلیپ‌بورد کپی شد" },
    error: { generic: "مشکلی پیش آمد. لطفاً دوباره امتحان کنید.", upload: "آپلود فایل ناموفق بود", save: "ذخیره تغییرات ناموفق بود", network: "خطای شبکه. لطفاً اتصال خود را بررسی کنید." },
    info: { processing: "در حال پردازش درخواست...", generating: "در حال تولید طرح شما..." },
  },

  editErrors: {
    contentRefused:
      "هوش مصنوعی نتوانست با این عکس کار کند؛ این اتفاق بیشتر برای عکس افراد بزرگسال یا چهره‌های شناخته‌شده رخ می‌دهد. لطفاً یک عکس واضح از کودک یا تصویر دیگری امتحان کنید.",
    unavailable:
      "سرویس هوش مصنوعی پاسخ نداد. اعتبار شما کسر نشده است؛ لطفاً چند لحظه بعد دوباره تلاش کنید.",
    generic: "ویرایش انجام نشد. لطفاً دوباره تلاش کنید.",
  },

  storybook: {
    pageTitle: "کتاب داستان خود را بسازید",
    pageSubtitle: "نقاشی فرزندتان را به داستان مصور جادویی تبدیل کنید",
    progress: "پیشرفت",
    stepOf: "مرحله {current} از {total}",

    steps: {
      upload: "به اومی نشون بده",
      uploadDesc: "یه نقاشی یا عکس برای اومی بفرست",
      magicPreview: "جادو",
      magicPreviewDesc: "ببین اومی چطور تبدیلش می‌کنه",
      concept: "داستان",
      conceptDesc: "داستان رو شکل بده",
      style: "ظاهر",
      styleDesc: "سبک هنری رو انتخاب کن",
      tale: "قصهٔ اومی",
      taleDesc: "اومی کتاب رو می‌نویسه و تصویرگری می‌کنه",
      printOptions: "دلخواه خودت",
      printOptionsDesc: "اندازه، جلد و کاغذ رو انتخاب کن",
      checkout: "پرداخت",
      checkoutDesc: "پرداخت آزمایشی امن",
      confirmation: "هورا!",
      confirmationDesc: "کتابت آماده‌ست",
    },

    fulfillment: {
      title: "کتاب داستانت رو چطور می‌خوای؟",
      subtitle: "یه گزینه انتخاب کن تا ادامه بدیم",
      required: "یه گزینه انتخاب کن",
      catalogUnavailable: "قیمت‌ها در دسترس نیست. کاتالوگ را دوباره بارگذاری کنید.",
      retryCatalog: "تلاش دوباره برای قیمت",
      pdfIncluded: "PDF هم همراهشه",
      options: {
        free: {
          title: "PDF رایگان",
          desc: "PDF ده‌صفحه‌ای کتابت رو همین حالا دانلود کن.",
        },
        voice: {
          title: "روایت صوتی",
          desc: "روایت صفحه‌به‌صفحه با صدای دوست‌داشتنی کودک.",
        },
        printed: {
          title: "کتاب چاپی",
          desc: "کتاب جلدسخت چاپی، تحویل درب منزل.",
        },
        both: {
          title: "چاپی + روایت",
          desc: "همه‌چی: کتاب چاپی، روایت صوتی، و PDF.",
        },
      },
    },

    printOptions: {
      title: "دلخواه خودت",
      subtitle: "حال‌و‌هوای کتاب چاپی‌ت رو انتخاب کن",
      included: "شامل",
      totalLabel: "مجموع",
      size: {
        label: "اندازه",
        standard: "استاندارد · ۲۰×۲۰ سانتی‌متر",
        large: "بزرگ · ۲۸×۲۸ سانتی‌متر",
      },
      cover: {
        label: "جلد",
        hardcover: "جلد سخت",
        linen: "پارچه‌ای ممتاز",
      },
      paper: {
        label: "کاغذ",
        matte: "مات",
        glossy: "براق",
      },
      giftBox: {
        label: "جعبهٔ هدیه",
        desc: "توی یه جعبهٔ هدیهٔ به‌یادموندنی برات می‌فرستیم.",
      },
    },

    checkout: {
      title: "پرداخت",
      subtitle: "سفارشت رو بررسی کن و تکمیلش کن",
      total: "مجموع",
      payButton: "پرداخت {price}",
      payButtonProcessing: "در حال پردازش...",
      prototypeMode: "حالت آزمایشی",
      prototypeDesc: "این پرداخت آزمایشیه. هیچ مبلغ واقعی کسر نمی‌شه.",
      prototypeNote: "هیچ کارتی شارژ نمی‌شه. این فقط یه پرداخت موفق شبیه‌سازی‌شده‌ست.",
      shippingTitle: "آدرس ارسال",
      shippingRequired: "برای کتاب چاپی آدرس ارسال لازم است.",
      quoteRequired: "قبل از پرداخت باید قیمت قفل شود.",
      catalogError: "قیمت کاتالوگ در دسترس نیست. دوباره تلاش کنید.",
      paymentFailed: "پرداخت ناموفق بود. دوباره تلاش کنید.",
      optional: "اختیاری",
      fullName: "نام کامل",
      line1: "نشانی خط ۱",
      line2: "نشانی خط ۲",
      city: "شهر",
      province: "استان",
      postalCode: "کد پستی",
      country: "کشور",
      phone: "تلفن",
    },

    confirmation: {
      title: "هورا! کتاب داستانت آماده‌ست",
      subtitle: {
        free: "PDFت رو از پایین دانلود کن و از داستانت لذت ببر.",
        voice: "کتابت آماده‌ست. روایت صوتی در حال آماده‌سازیه.",
        printed: "کتاب چاپی‌ت در راهه!",
        both: "کتاب چاپی‌ت در راهه و روایت صوتی هم آماده می‌شه.",
      },
      orderNumber: "شمارهٔ سفارش #",
      trackOrder: "پیگیری سفارش",
      downloadPDF: "دانلود PDF",
      voiceTitle: "روایت صوتی",
      voicePreparing: "داریم روایت رو آماده می‌کنیم. به‌زودی تو کتابخونه‌ت پیداش می‌کنی.",
      voiceReady: "روایت آماده‌ست؛ تو کتابخونه‌ت می‌تونی پخشش کنی.",
    },

    input: {
      title: "بیایید یک داستان بسازیم!",
      subtitle: "نقاشی فرزندتان را آپلود کنید و داستان را بگویید",
      uploadDrawing: "نقاشی فرزندتان را آپلود کنید",
      charactersTrayTitle: "کاراکترها",
      removeCharacterTitle: "این کاراکتر حذف شود؟",
      removeCharacterDescription: "این کاراکتر از داستان حذف می‌شود.",
      removeCharacterConfirm: "حذف",
      removeCharacterCancel: "انصراف",
      characterRemoved: "کاراکتر حذف شد",
      storyMethod: "چگونه می‌خواهید داستان را بگویید؟",
      writeIt: "بنویسید",
      recordIt: "ضبط کنید",
      storyPlaceholder: "یک دختر کوچولو ماشین جادویی پیدا می‌کند که می‌تواند پرواز کند و گربه‌اش را به ماجراجویی به ماه می‌برد...",
      recording: "در حال ضبط...",
      recordingMax: "حداکثر ۱ دقیقه",
      tapToRecord: "برای ضبط بزنید",
      tapToStop: "برای توقف بزنید",
      reRecord: "ضبط مجدد",
      useRecording: "از این ضبط استفاده کن",
      childAge: "سن کودک",
      ageToddler: "خردسال",
      ageEarlyReader: "نوآموز",
      ageChapterBook: "کتاب‌خوان",
      illustrationStyle: "سبک تصویرسازی",
      styleWatercolor: "آبرنگ",
      styleCartoon: "کارتونی",
      styleCrayon: "مدادشمعی",
      styleClassic: "کلاسیک",
      styleAnime: "انیمه",
      comingSoon: "به‌زودی",
      voiceNarration: "صدای راوی داستان",
      animatedStory: "داستان متحرک",
      micDenied: "دسترسی به میکروفون رد شد. لطفاً اجازه دسترسی بدهید یا داستان را تایپ کنید.",
      drawingRequired: "لطفاً یک نقاشی آپلود کنید.",
      storyRequired: "لطفاً داستان را بنویسید یا ضبط کنید (حداقل ۱۰ کاراکتر).",
      audioRequired: "لطفاً ابتدا داستان را ضبط کنید.",
      illustrationStyleRequired: "لطفاً یک سبک تصویرگری انتخاب کنید.",
      childAgeRequired: "لطفاً یک گروه سنی برای کودک انتخاب کنید.",
      authorName: "نام نویسنده",
      authorPlaceholder: "چه کسی این داستان را نوشته؟",
      selectChild: "یکی از فرزندان پروفایل خود را انتخاب کنید",
      customAuthor: "یا یک نام تایپ کنید",
      authorRequired: "لطفاً نام نویسنده را وارد کنید.",
      storyLanguage: "زبان داستان",
      languageEnglish: "English",
      languagePersian: "فارسی",
    },

    style: {
      title: "ظاهر کتاب داستان را انتخاب کنید",
      subtitle: "مخاطب و راوی را انتخاب کنید.",
      voiceHint: "یک راوی صوتی اضافه کنید تا داستان را بلند بخواند",
      readingStyle: "سبک خواندن داستان",
      readingStyleHint: "اول سبک خواندن را انتخاب کنید، بعد نام صدا را.",
      styleRequired: "برای ادامه یک سبک خواندن انتخاب کنید.",
      voiceRequired: "برای ادامه نام صدا را انتخاب کنید.",
      selectionSummary: "{style} · {voice}",
      styles: {
        bedtime: { label: "قبل از خواب", hint: "آرام، ملایم و با ریتم آسوده" },
        daytime: { label: "روزانه", hint: "زنده و جذاب برای شنیدن در طول روز" },
        readAlong: { label: "همراه‌خوانی", hint: "تلفظ روشن و مکث‌های سنجیده" },
      },
    },

    concept: {
      title: "داستانت را بگو",
      subtitle: "بنویس یا خودت تعریف کن و ضبط کن.",
      transcribing: "در حال تبدیل صدا به متن…",
    },

    transcript: {
      title: "بازبینی ایده داستان",
      rawLabel: "این را از ضبط شنیدیم:",
      warning: "بعضی کلمات را نتوانستیم بشنویم. لطفاً هر چیزی که اشتباه به نظر می‌رسد را اصلاح کنید.",
      editLabel: "داستان را در زیر ویرایش کنید:",
      replayAudio: "پخش مجدد صدا",
      confirm: "تأیید داستان",
    },

    image: {
      title: "پیش‌نمایش جادویی",
      subtitle: "نقاشی شما جان گرفت!",
      originalLabel: "نقاشی اصلی",
      resultLabel: "نتیجه جادویی",
      addNotes: "یادداشت اضافه کنید (اختیاری)",
      notesPlaceholder: "سگ را بزرگ‌تر کن، باید لبخند بزند...",
      regenerate: "بازسازی",
      edit: "ویرایش",
      submitEdit: "ارسال ویرایش",
      generating: "در حال تبدیل نقاشی شما...",
    },

    generate: {
      title: "در حال ساخت کتاب داستان",
      analyzing: "تحلیل نقاشی شما...",
      writing: "نوشتن داستان...",
      characters: "طراحی شخصیت‌ها...",
      illustrating: "تصویرسازی صفحات...",
      pageProgress: "صفحه {current} از {total}",
      assembling: "مونتاژ کتاب داستان...",
      estimatedTime: "معمولاً حدود ۲ دقیقه طول می‌کشد",
      ready: "کتاب داستان شما آماده است!",
      summary: "{pages} صفحه · {readTime} دقیقه مطالعه",
      reviewButton: "بازبینی کتاب",
      assetsProgress: "{current}/{total} آیتم",
      previewSoFar: "تا اینجا ذخیره شده",
      voicePagesProgress: "{current}/{total} صفحه",
      regenConfirm:
        "داستان جدید تولید می‌شود و قدم‌های بعدی از نو اجرا می‌شوند (ممکن است اعتبار کم شود). ادامه می‌دهید؟",
      error: {
        title: "مشکلی پیش آمد",
        savedMessage: "نگران نباشید — داستان و تنظیمات شما ذخیره شده‌اند. روی تلاش مجدد بزنید تا از همان‌جا ادامه دهد.",
        retryButton: "تلاش مجدد",
        storyFailed: "هنگام نوشتن داستان مشکلی پیش آمد. نقاشی و تنظیمات شما ذخیره شده‌اند.",
        promptsFailed: "هنگام برنامه‌ریزی تصاویر مشکلی پیش آمد. داستان شما ذخیره شده.",
        assetsFailed: "هنگام ساخت مرجع شخصیت‌ها مشکلی پیش آمد.",
        illustrationsFailed: "هنگام ترسیم صفحات مشکلی پیش آمد.",
        fallback: "ساخت ناموفق بود. لطفاً دوباره تلاش کنید.",
      },
      voice: {
        title: "روایت صوتی",
        enriching: "غنی‌سازی متن داستان...",
        recording: "ضبط روایت...",
        complete: "روایت تکمیل شد",
      },
      theater: {
        stages: [
          "در حال بررسی جزئیات...",
          "نقشه‌برداری ابعاد...",
          "ترکیب رنگ‌های دیجیتال...",
          "مونتاژ اثر شما...",
          "صیقل دادن درخشش نهایی...",
        ],
        messages: [
          "اندازه‌گیری بال‌های اژدها...",
          "ترکیب رنگ‌های دیجیتال...",
          "گرم کردن کوره...",
          "اسکن برای حداکثر بامزگی...",
          "اضافه کردن درخشش مخفی...",
          "پرداخت جزئیات نهایی...",
          "تقریباً تمام شد — کمال زمان می‌برد...",
        ],
        timeEstimate: "معمولاً ۶۰ تا ۹۰ ثانیه طول می‌کشد",
        funFacts: [
          "آیا می‌دانستید؟ هر تصویر به‌صورت منحصربه‌فرد ساخته می‌شود — هیچ دو کتاب داستانی مثل هم نیستند.",
          "آیا می‌دانستید؟ هوش مصنوعی ما هر جزئیات نقاشی اصلی را حفظ می‌کند، حتی خطوط لرزان.",
          "آیا می‌دانستید؟ هر صفحه کتاب با سبک هنری کودک شما تصویرسازی می‌شود.",
          "آیا می‌دانستید؟ ما از همان فناوری هوش مصنوعی استودیوهای حرفه‌ای انیمیشن استفاده می‌کنیم.",
          "آیا می‌دانستید؟ نقاشی کودک شما کارگردان خلاق است — هوش مصنوعی فقط دستورات را اجرا می‌کند.",
        ],
      },
    },

    review: {
      title: "بازبینی کتاب داستان",
      pageOf: "صفحه {current} از {total}",
      editText: "ویرایش متن داستان",
      editIllustration: "ویرایش تصویر",
      submitIllustrationEdit: "ارسال ویرایش",
      editTitle: "ویرایش عنوان",
      changeAuthor: "تغییر نویسنده",
      regenerateCover: "بازسازی جلد",
      previous: "قبلی",
      next: "بعدی",
      lookGreat: "عالیه! ادامه بدید",
      theEnd: "پایان",
      madeWith: "ساخته شده با عشق توسط روبی",
      coverFallback: "داستان شما",
      flipHint: "کلیک کنید یا بکشید تا صفحات ورق بخورند",
      prevPage: "صفحه قبل",
      nextPage: "صفحه بعد",
      backCoverTagline: "هر نقاشی داستانی دارد",
      readAloud: "پخش خودکار داستان",
      stopReading: "توقف پخش خودکار",
      playNarration: "پخش روایت",
      pauseNarration: "توقف روایت",
      pageLabel: "صفحه {pageNumber}",
      noPagesToDisplay: "صفحه‌ای برای نمایش نیست",
    },

    extras: {
      title: "انیمیشن",
      voiceTitle: "صدای راوی داستان",
      voiceDesc: "هر صفحه با صدای دوستانه و مناسب کودک خوانده می‌شود.",
      animationTitle: "داستان متحرک",
      animationDesc: "کتاب داستانتان را به صورت ویدیوی متحرک ببینید.",
      notifyMe: "وقتی آماده شد خبرم کنید",
      emailPlaceholder: "your@email.com",
    },

    download: {
      title: "دریافت کتاب داستان",
      freeTitle: "کتاب داستان دیجیتال",
      freePrice: "رایگان",
      freeFeature1: "PDF مصور ۱۰ صفحه‌ای",
      freeFeature2: "لینک اشتراک‌گذاری",
      freeButton: "دانلود PDF",
      premiumTitle: "با روایت صوتی",
      premiumPrice: "۱٬۲۵۰٬۰۰۰ ریال",
      premiumFeature1: "همه امکانات رایگان",
      premiumFeature2: "روایت صفحه به صفحه",
      premiumFeature3: "انتخاب صدا",
      premiumPlusTitle: "با انیمیشن",
      premiumPlusPrice: "۲٬۵۰۰٬۰۰۰ ریال",
      premiumPlusFeature1: "همه امکانات ویژه",
      premiumPlusFeature2: "ویدیوی داستان متحرک",
      physicalTitle: "چاپ جلد سخت",
      physicalPrice: "۳٬۷۵۰٬۰۰۰ ریال",
      physicalFeature1: "کتاب جلد سخت باکیفیت",
      physicalFeature2: "کاغذ مرغوب",
      physicalFeature3: "ارسال به درب منزل",
    },

    newProject: {
      button: "پروژه جدید",
      title: "شروع کتاب داستان جدید؟",
      description: "پیشرفت فعلی شما از دست خواهد رفت.",
      cancel: "انصراف",
      confirm: "شروع جدید",
    },
  },

  notFound: {
    subtitle: "صفحه پیدا نشد!",
    returnHome: "بازگشت به خانه",
  },

  admin: {
    verifyingAccess: "در حال بررسی دسترسی",
    checkingPrivileges: "بررسی دسترسی مدیریتی شما...",
    accessDenied: "دسترسی غیرمجاز",
    noAdminAccess: "شما دسترسی مدیریتی به این صفحه ندارید.",
    returnHome: "بازگشت به خانه",
    title: "داشبورد مدیریت",
    subtitle: "مدیریت سفارشات، پروژه‌ها و نظارت بر وضعیت تولید",
    totalOrders: "کل سفارشات",
    totalRevenue: "درآمد کل",
    avgOrderValue: "میانگین ارزش سفارش",
    shippedOrders: "سفارشات ارسال‌شده",
    totalProjects: "کل پروژه‌ها",
    ordersTab: "سفارشات",
    projectsTab: "پروژه‌ها",
    searchOrders: "جستجوی سفارشات...",
    searchProjects: "جستجو بر اساس عنوان، ایمیل، سفارش...",
    allStatus: "همه وضعیت‌ها",
    allStyles: "همه سبک‌ها",
    allTypes: "همه انواع",
    loadingOrders: "بارگذاری سفارشات...",
    loadingProjects: "بارگذاری پروژه‌ها...",
    noOrdersFound: "سفارشی یافت نشد",
    noProjectsFound: "پروژه‌ای یافت نشد",
    updating: "به‌روزرسانی...",
    statusUpdated: "وضعیت به‌روز شد",
    statusUpdatedDesc: "وضعیت سفارش به {status} تغییر کرد",
    updateFailed: "به‌روزرسانی ناموفق",
    updateFailedDesc: "به‌روزرسانی وضعیت سفارش ناموفق بود",
    errorLoadingOrders: "خطا در بارگذاری سفارشات",
    errorLoadingOrdersDesc: "بارگذاری سفارشات از پایگاه داده ناموفق بود",
    errorLoadingProjects: "خطا در بارگذاری پروژه‌ها",
    errorLoadingProjectsDesc: "بارگذاری پروژه‌ها از پایگاه داده ناموفق بود",
    orderNumber: "شماره سفارش",
    customer: "مشتری",
    email: "ایمیل",
    project: "پروژه",
    status: "وضعیت",
    total: "مبلغ",
    created: "تاریخ ایجاد",
    actions: "عملیات",
    preview: "پیش‌نمایش",
    projectTitle: "عنوان",
    userEmail: "ایمیل کاربر",
    type: "نوع",
    style: "سبک",
  },

  orderDetails: {
    loadingOrder: "بارگذاری سفارش",
    fetchingDetails: "دریافت جزئیات سفارش...",
    accessDenied: "دسترسی غیرمجاز",
    noPermission: "شما مجوز مشاهده جزئیات سفارش را ندارید.",
    backToDashboard: "بازگشت به داشبورد",
    orderNotFound: "سفارش یافت نشد",
    orderNotFoundDesc: "سفارش مورد نظر وجود ندارد یا حذف شده است.",
    order: "سفارش",
    createdAt: "ایجاد شده {date}",
    customerInfo: "اطلاعات مشتری",
    name: "نام",
    email: "ایمیل",
    phone: "تلفن",
    shippingAddress: "آدرس ارسال",
    projectDetails: "جزئیات پروژه",
    projectTitle: "عنوان پروژه",
    styleLabel: "سبک",
    sizeLabel: "اندازه",
    materialLabel: "متریال",
    colorPlan: "پلان رنگ",
    statusHistory: "تاریخچه وضعیت",
    noStatusHistory: "تاریخچه وضعیتی موجود نیست",
    orderSummary: "خلاصه سفارش",
    orderTotal: "مبلغ سفارش",
    paymentStatus: "وضعیت پرداخت",
    paid: "پرداخت شده",
    pending: "در انتظار",
    orderNumber: "شماره سفارش",
    lastUpdated: "آخرین به‌روزرسانی",
    trackingInfo: "اطلاعات پیگیری",
    trackingCode: "کد پیگیری",
    trackingPlaceholder: "کد پیگیری را وارد کنید",
    estimatedDelivery: "تحویل تخمینی",
    updateTracking: "به‌روزرسانی پیگیری",
    updating: "به‌روزرسانی...",
    trackingUpdated: "پیگیری به‌روز شد",
    trackingUpdatedDesc: "اطلاعات پیگیری با موفقیت به‌روز شد",
    trackingUpdateFailed: "به‌روزرسانی ناموفق",
    trackingUpdateFailedDesc: "به‌روزرسانی اطلاعات پیگیری ناموفق بود",
    errorLoadingOrder: "خطا در بارگذاری سفارش",
    errorLoadingOrderDesc: "بارگذاری جزئیات سفارش ناموفق بود",
  },

  qualitySafety: {
    hero: {
      title: "کیفیت و ایمنی در روبی",
      subtitle: "ایمنی و شادی فرزند شما غیرقابل مذاکره است. ببینید چگونه از هر دو محافظت می‌کنیم.",
    },
    materials: {
      title: "مواد ما",
      subtitle: "هر ماده به طور مستقل آزمایش و برای استفاده کودکان تأیید شده است",
      pla: {
        name: "PLA استاندارد",
        description: "زیست‌تجزیه‌پذیر، گیاهی، پرداخت صاف. بهترین برای نمایش و بازی سبک.",
        badges: ["بدون BPA", "مطابق FDA", "زیست‌تجزیه‌پذیر"],
      },
      petg: {
        name: "PETG مقاوم",
        description: "مقاوم در برابر ضربه، رنگ‌های درخشان. ساخته شده برای بازی فعال.",
        badges: ["تأیید ایمنی کودک", "مقاوم ضربه", "رنگ درخشان"],
      },
      tpu: {
        name: "TPU انعطاف‌پذیر",
        description: "نرم، خم‌شونده، قابل بغل کردن. عالی برای کودکان خردسال.",
        badges: ["غیرسمی", "انعطاف‌پذیر", "لمس نرم"],
      },
      resin: {
        name: "رزین با جزئیات بالا",
        description: "پرداخت فوق‌العاده صاف، جزئیات فوتورئالیستی. بهترین برای قطعات نمایشی و کلکسیونی.",
        badges: ["فوق‌العاده صاف", "فوتورئالیستی", "درجه کلکسیونی"],
      },
    },
    process: {
      title: "فرآیند کیفیت ما",
      subtitle: "هر اسباب‌بازی از سه نقطه بازرسی سخت‌گیرانه عبور می‌کند قبل از رسیدن به فرزندتان",
      steps: {
        inspection: {
          title: "بازرسی پس از چاپ",
          description: "بررسی یکپارچگی ساختاری، ثبات لایه‌ها و کیفیت چاپ بر اساس استانداردهای ما.",
        },
        review: {
          title: "بازبینی پس از پرداخت",
          description: "تأیید دقت رنگ، صافی سطح و وفاداری جزئیات به پیش‌نمایش تأیید شده.",
        },
        approval: {
          title: "تأیید قبل از ارسال",
          description: "بررسی نهایی بسته‌بندی، جلوگیری از آسیب و مهر کیفیت قبل از ارسال.",
        },
      },
    },
    privacy: {
      title: "حریم خصوصی فرزند شما",
      commitments: [
        "ما هرگز بدون رضایت صریح از آپلودهای شما برای آموزش مدل‌های هوش مصنوعی استفاده نمی‌کنیم.",
        "خانواده‌ها مالکیت کامل تمام آثار ارسالی را حفظ می‌کنند.",
        "مطابق با COPPA و GDPR-K — مالکیت حساب والد/سرپرست الزامی است.",
        "حذف داده‌ها بنا به درخواست — هنر شما، کنترل شما.",
        "تمام آپلودها در حین انتقال و در حالت استراحت رمزگذاری شده‌اند.",
      ],
    },
    guarantee: {
      title: "تضمین ۱۰۰٪ رضایت",
      description: "اگر محصول نهایی با پیش‌نمایش تأیید شده مطابقت نداشته باشد، رایگان دوباره می‌سازیم یا بازگشت کامل وجه. بدون مانع. بدون دردسر.",
      button: "شروع ساخت — بدون ریسک",
    },
  },

  heroPanel: {
    riko: {
      chipLabel: "اسباب‌بازی‌ساز",
      name: "ریکو",
      hookBefore: "اون هیولای لرزون روی یخچال؟",
      hookAfter: "ریکو اون رو ",
      hookHighlight: "واقعی می‌کنه.",
      body: "یک نقاشی یا عکس مورد علاقه بفرست — ریکو با یک قلقلک کوچک تبدیلش می‌کنه به یک اسباب‌بازی بغلی که در خونه‌ات می‌رسه.",
      ctaLabel: "با ریکو دوست شو",
      howLabel: "جادو چطور کار می‌کنه",
    },
    umi: {
      chipLabel: "قصه‌گو",
      name: "اومی",
      hookBefore: "هر نقاشی داره یک قصه زمزمه می‌کنه.",
      hookAfter: "اومی می‌تونه ",
      hookHighlight: "بشنوه.",
      body: "اون قصه رو تبدیل می‌کنه به یک کتاب تصویری زیبا، با بچه‌ی شما به‌عنوان قهرمان و اسمش روی جلد.",
      ctaLabel: "با اومی کتاب رو باز کن",
      howLabel: "جادو چطور کار می‌کنه",
    },
    bibi: {
      chipLabel: "انیماتور",
      name: "بی‌بی",
      hookBefore: "نقاشی‌ها روی دیوار خسته می‌شن.",
      hookAfter: "بی‌بی ",
      hookHighlight: "بیدارشون می‌کنه.",
      body: "یک نقاشی یا عکس بفرست و ببین چطور پلک می‌زنه، می‌خنده و توی فیلم کوچیک خودش می‌رقصه.",
      ctaLabel: "با بی‌بی بیدارش کن",
      howLabel: "جادو چطور کار می‌کنه",
    },
    yoyo: {
      chipLabel: "بازی‌ساز",
      name: "یویو",
      hookBefore: "یویو هیچ‌وقت نمی‌گه «دست نزن» —",
      hookAfter: "یویو می‌گه ",
      hookHighlight: "«استارت رو بزن!»",
      body: "هر نقاشی یا عکسی می‌شه ستاره‌ی بازی کوچیک خودش — و بچه‌ی شما کنترل رو به دست می‌گیره.",
      ctaLabel: "با یویو استارت بزن",
      howLabel: "جادو چطور کار می‌کنه",
    },
  },
  animation: {
    length: {
      title: "مدت انیمیشن",
      subtitle: "انیمیشن نهایی چقدر طول بکشد؟",
      secondsSuffix: "ثانیه",
    },

    steps: {
      upload: "بی‌بی رو نشون بده",
      uploadDesc: "یک نقاشی یا عکس برای بی‌بی بفرست",
      magicPreview: "جادو",
      magicPreviewDesc: "ببین بی‌بی چطور اونو به شخصیت تبدیل می‌کنه",
      concept: "داستان",
      conceptDesc: "داستان را شکل بده",
      style: "ظاهر",
      styleDesc: "سبک هنری را انتخاب کن",
      storyboardReview: "صحنه‌ها",
      storyboardReviewDesc: "قبل از ویدیو فریم‌های کلید را بررسی کن",
      tale: "قصهٔ بی‌بی",
      taleDesc: "بی‌بی داستان و انیمیشن تو رو می‌سازه",
      checkout: "پرداخت",
      checkoutDesc: "پرداخت نمونه‌ای امن",
      confirmation: "هورا!",
      confirmationDesc: "انیمیشنت آماده‌ست",
    },

    storyboardReview: {
      title: "صحنه‌ها را بررسی کن",
      subtitle:
        "متن صحنه را ویرایش کن یا تصویر را بازتولید کن، سپس برای ساخت فیلم تأیید کن.",
      lockedSubtitle:
        "صحنه‌ها تأیید شده‌اند — تصاویر فقط خواندنی هستند تا فیلم ساخته شود.",
      lockedHint: "برای پیشرفت ساخت یا دیدن فیلم به مرحله داستان برو.",
      goToTale: "برو به داستان",
      approve: "تأیید صحنه‌ها و ساخت انیمیشن",
      approving: "در حال شروع ویدیو…",
      remakeVideo: "تولید مجدد ویدیو",
      remakeSubtitle:
        "می‌توانی صحنه‌ها را ویرایش کنی و دوباره ویدیو بسازی.",
      remakeHint: "بعد از ویرایش متن یا تصویر، تولید مجدد ویدیو را بزن.",
      editStoryboard: "ویرایش صحنه‌ها و تولید مجدد",
      editScene: "ویرایش صحنه",
      regenerate: "بازتولید فریم",
      missingImage: "فریم کلید آماده نیست",
      startFrame: "شروع",
      endFrame: "پایان",
      waitingForImages:
        "وقتی همه صحنه‌ها فریم شروع و پایان داشته باشند، تأیید فعال می‌شود.",
      textSaved: "متن صحنه ذخیره شد",
      textSaveFailed: "ذخیره متن صحنه ناموفق بود",
      regenStarted: "بازتولید شروع شد",
      regenStartedDesc: "به‌محض آماده‌شدن تصویر، صحنه به‌روز می‌شود…",
      regenFailed: "بازتولید ناموفق بود",
      regenTimedOut: "بازتولید زمان‌بر شد — دوباره تلاش کن",
      editBusy: "ویرایش صحنه در حال انجام است…",
    },

    fulfillment: {
      title: "انیمیشنت رو چطور می‌خوای؟",
      subtitle: "یک پلن انتخاب کن تا ادامه بدی",
      required: "برای ادامه یک پلن انتخاب کن",
      catalogUnavailable: "قیمت‌ها در دسترس نیست. کاتالوگ را دوباره بارگذاری کنید.",
      retryCatalog: "تلاش مجدد قیمت‌ها",
      options: {
        free: {
          title: "ویدیوی رایگان",
          desc: "انیمیشن نهایی، دانلود فوری MP4.",
        },
        hd: {
          title: "HD",
          desc: "فیلم نهایی با وضوحی که انتخاب کرده‌اید، بدون واترمارک.",
        },
        premium: {
          title: "پریمیوم",
          desc: "وضوح انتخاب‌شده به‌همراه صداگذاری شخصیت و موسیقی پس‌زمینه.",
        },
        ultimate: {
          title: "آلتیمیت",
          desc: "پریمیوم به‌علاوهٔ انیمیشن طولانی‌تر.",
        },
      },
    },

    checkout: {
      title: "پرداخت",
      subtitle: "سفارشت رو بررسی کن و نهایی کن",
      total: "مجموع",
      payButton: "پرداخت {price}",
      payButtonProcessing: "در حال پردازش...",
      prototypeMode: "حالت نمونه",
      prototypeDesc: "این یک پرداخت نمونه است. هیچ مبلغ واقعی کسر نمی‌شود.",
      prototypeNote: "هیچ کارتی برداشت نمی‌شود. این یک پرداخت موفق شبیه‌سازی‌شده است.",
      quoteRequired: "قبل از پرداخت باید قیمت قفل شود.",
      catalogError: "قیمت کاتالوگ در دسترس نیست. دوباره تلاش کنید.",
      paymentFailed: "پرداخت ناموفق بود. دوباره تلاش کنید.",
    },

    confirmation: {
      title: "هورا! انیمیشنت آماده شد",
      subtitle: {
        free: "ویدیو رو از پایین دانلود کن و لذت ببر.",
        hd: "فیلم با وضوحی که انتخاب کرده‌اید آمادهٔ دانلود است. جزئیات سفارش در حساب کاربری‌تان است.",
        premium: "انیمیشن پریمیوم آماده دانلوده. جزئیات سفارش در حساب کاربری‌ته.",
        ultimate: "انیمیشن آلتیمیت آماده دانلوده. جزئیات سفارش در حساب کاربری‌ته.",
      },
      orderNumber: "سفارش شماره ",
      trackOrder: "پیگیری سفارش",
      downloadVideo: "دانلود ویدیو",
      videoStillRendering: "ویدیوت هنوز در حال رندره — یک لحظهٔ دیگه دوباره امتحان کن.",
    },

    concept: {
      title: "داستانت رو برامون تعریف کن",
      subtitle: "بنویسش یا خودت تعریفش کن و ضبط کن.",
      transcribing: "در حال تبدیل صدا به متن…",
    },

    style: {
      title: "ظاهر انیمیشن را انتخاب کنید",
      subtitle: "مخاطب و راوی را انتخاب کنید.",
    },

    input: {
      writeIt: "بنویسید",
      recordIt: "ضبط کنید",
      storyPlaceholder: "یک دختر کوچولو ماشین جادویی پیدا می‌کند که می‌تواند پرواز کند و گربه‌اش را به ماجراجویی به ماه می‌برد...",
      recordingMax: "حداکثر ۱ دقیقه",
      tapToRecord: "برای ضبط بزنید",
      tapToStop: "برای توقف بزنید",
      reRecord: "ضبط مجدد",
      useRecording: "از این ضبط استفاده کن",
      childAge: "سن کودک",
      ageToddler: "خردسال",
      ageEarlyReader: "نوآموز",
      ageChapterBook: "کتاب‌خوان",
      illustrationStyle: "سبک تصویرسازی",
      comingSoon: "به‌زودی",
      micDenied: "دسترسی به میکروفون رد شد. لطفاً اجازه دسترسی بدهید یا داستان را تایپ کنید.",
      storyRequired: "لطفاً داستان را بنویسید یا ضبط کنید (حداقل ۱۰ کاراکتر).",
      illustrationStyleRequired: "لطفاً یک سبک تصویرگری انتخاب کنید.",
      childAgeRequired: "لطفاً یک گروه سنی برای کودک انتخاب کنید.",
      authorName: "نام نویسنده",
      authorPlaceholder: "چه کسی این داستان را نوشته؟",
      authorRequired: "لطفاً نام نویسنده را وارد کنید.",
      storyLanguage: "زبان داستان",
      resolution: "وضوح انیمیشن",
      resolutionHint: "برای همهٔ صحنه‌ها و فایل دانلودی اعمال می‌شود.",
      resolutionDelivery: "وضوح دانلود",
      resolutionUnsupportedByModel: "برخی گزینه‌های وضوح ({resolutions}) به‌دلیل عدم پشتیبانی مدل فعال ویدیو غیرفعال شده‌اند.",
      resolutionUnsupportedError: "وضوح انتخاب‌شده توسط مدل فعال ویدیو پشتیبانی نمی‌شود. لطفاً وضوح سازگار را انتخاب کنید.",
      languageEnglish: "English",
      languagePersian: "فارسی",
      uploadDrawing: "نقاشی یا عکس آپلود کنید",
    },

    transcript: {
      title: "بازبینی ایده داستان",
      rawLabel: "این را از ضبط شنیدیم:",
      warning: "بعضی کلمات را نتوانستیم بشنویم. لطفاً هر چیزی که اشتباه به نظر می‌رسد را اصلاح کنید.",
      editLabel: "داستان را در زیر ویرایش کنید:",
      replayAudio: "پخش مجدد صدا",
      confirm: "تأیید داستان",
    },

    image: {
      notesPlaceholder: "سگ را بزرگ‌تر کن، باید لبخند بزند...",
    },

    generate: {
      ready: "انیمیشن شما آماده است!",
      summary: "{pages} صحنه · فیلم {readTime} دقیقه‌ای",
      reviewButton: "بازبینی انیمیشن",
      assetsProgress: "{current}/{total} آیتم",
      previewSoFar: "تا اینجا ذخیره شده",
      pageProgress: "صحنه {current} از {total}",
      regenConfirm:
        "داستان جدید تولید می‌شود و قدم‌های بعدی از نو اجرا می‌شوند (ممکن است اعتبار کم شود). ادامه می‌دهید؟",
      error: {
        title: "مشکلی پیش آمد",
        savedMessage: "نگران نباشید — داستان و تنظیمات شما ذخیره شده‌اند. روی تلاش مجدد بزنید تا از همان‌جا ادامه دهد.",
        retryButton: "تلاش مجدد",
        storyFailed: "هنگام نوشتن داستان مشکلی پیش آمد. نقاشی و تنظیمات شما ذخیره شده‌اند.",
        promptsFailed: "هنگام برنامه‌ریزی صحنه‌ها مشکلی پیش آمد. داستان شما ذخیره شده.",
        assetsFailed: "هنگام ساخت مرجع شخصیت‌ها مشکلی پیش آمد.",
        illustrationsFailed: "هنگام رندر صحنه‌ها مشکلی پیش آمد.",
        storyboardsFailed: "طراحی استوری‌بورد با مشکل مواجه شد. لطفاً دوباره تلاش کنید.",
        scenePromptsFailed: "نوشتن دستور صحنه با مشکل مواجه شد. لطفاً دوباره تلاش کنید.",
        videoFailed: "رندر ویدیو با مشکل مواجه شد. لطفاً دوباره تلاش کنید.",
        fallback: "ساخت ناموفق بود. لطفاً دوباره تلاش کنید.",
      },
      phases: {
        writing: "در حال نوشتن داستان",
        mapping: "نقشه‌برداری از جزئیات",
        painting: "نقاشی هنر مرجع",
        drawing: "کشیدن فریم‌های ثابت",
        storyboards: "طراحی هر شات (استوری‌بورد)",
        directing: "کارگردانی حرکت (دستور صحنه)",
        filming: "فیلمبرداری (ویدیو)",
        polish: "پرداخت نهایی",
      },
      theater: {
        stages: [
          "در حال بررسی جزئیات...",
          "نقشه‌برداری ابعاد...",
          "ترکیب رنگ‌های دیجیتال...",
          "مونتاژ اثر شما...",
          "صیقل دادن درخشش نهایی...",
        ],
        messages: [
          "اندازه‌گیری بال‌های اژدها...",
          "ترکیب رنگ‌های دیجیتال...",
          "گرم کردن کوره...",
          "اسکن برای حداکثر بامزگی...",
          "اضافه کردن درخشش مخفی...",
          "پرداخت جزئیات نهایی...",
          "تقریباً تمام شد — کمال زمان می‌برد...",
        ],
        timeEstimate: "معمولاً ۶۰ تا ۹۰ ثانیه طول می‌کشد",
        funFacts: [
          "آیا می‌دانستید؟ هر صحنه به‌صورت منحصربه‌فرد ساخته می‌شود — هیچ دو انیمیشنی مثل هم نیستند.",
          "آیا می‌دانستید؟ هوش مصنوعی ما هر جزئیات نقاشی اصلی را حفظ می‌کند، حتی خطوط لرزان.",
          "آیا می‌دانستید؟ هر صحنه با سبک هنری کودک شما کارگردانی می‌شود.",
          "آیا می‌دانستید؟ ما از همان فناوری هوش مصنوعی استودیوهای حرفه‌ای انیمیشن استفاده می‌کنیم.",
          "آیا می‌دانستید؟ نقاشی کودک شما کارگردان خلاق است — هوش مصنوعی فقط دستورات را اجرا می‌کند.",
        ],
      },
    },

    review: {
      title: "انیمیشنت رو بازبینی کن",
      coverFallback: "انیمیشن شما",
      noPagesToDisplay: "صحنه‌ای برای نمایش نیست",
      watchHint: "ویدیوی نهایی را پخش کن — مثل یک فیلم کوتاه",
      videoNotReady: "ویدیوی نهایی هنوز آماده نیست. صحنه‌ها را پایین ببین.",
      scenesHint: "کلیپ‌های هر صحنه",
      sceneLabel: "صحنه {n}",
      flipHint: "کلیک کنید یا بکشید تا صفحات ورق بخورند",
      prevPage: "صفحه قبل",
      nextPage: "صفحه بعد",
      theEnd: "پایان",
      madeWith: "ساخته شده با عشق توسط روبی",
      backCoverTagline: "هر نقاشی داستانی دارد",
      editText: "ویرایش متن صحنه",
      editIllustration: "ویرایش صحنه",
      submitIllustrationEdit: "ارسال ویرایش",
    },


    newProject: {
      button: "پروژه جدید",
      title: "شروع انیمیشن جدید؟",
      description: "پیشرفت فعلی شما از دست خواهد رفت.",
      cancel: "انصراف",
      confirm: "شروع جدید",
    },
  },

  productCta: {
    chooseHeading: "جادوی خود را انتخاب کنید",
    chooseSubheading: "سه راه برای تبدیل نقاشی یا عکس کودک شما به چیزی ماندگار.",
    toy: "ساخت اسباب‌بازی",
    storybook: "ساخت کتاب داستان",
    animation: "ساخت انیمیشن",
  },

  contactDetails: {
    generalEmail: "hello@rubby.co.uk",
    privacyEmail: "privacy@rubby.co.uk",
    legalEmail: "legal@rubby.co.uk",
    companyLine: "روبی — یک استودیوی خلاق برای خانواده‌ها، مستقر در بریتانیا.",
  },

  legalDates: {
    termsLastUpdated: "۱۶ ژوئن ۲۰۲۶",
    privacyLastUpdated: "۱۶ ژوئن ۲۰۲۶",
  },

  faqExtra: {
    digital: {
      title: "کتاب داستان، انیمیشن و اعتبارها",
      questions: {
        storybook: { q: "کتاب داستان شخصی‌سازی‌شده چطور کار می‌کند؟", a: "نقاشی یا عکس کودکتان را آپلود می‌کنید، سبک را انتخاب می‌کنید، چند جزئیات درباره فرزندتان می‌گویید و هوش مصنوعی ما یک کتاب تصویری منحصربه‌فرد می‌نویسد و تصویرسازی می‌کند که او قهرمان آن است. می‌توانید هر صفحه را بازبینی کنید، تغییر بخواهید، و قبل از سفارش چاپی یا دانلود PDF روایت انگلیسی یا فارسی اضافه کنید." },
        animation: { q: "یک فیلم انیمیشن از چه ساخته می‌شود؟", a: "یک نقاشی یا عکس را به فیلم کوتاه کارگردانی‌شده تبدیل می‌کنیم: داستان، تصویر صحنه‌به‌صحنه، صدای شخصیت‌ها و موسیقی. ابتدا استوری‌بورد را می‌بینید و هر صحنه را قبل از رندر نهایی تأیید می‌کنید. مدت زمان فعلی حدود ۱۵ تا ۶۰ ثانیه است." },
        credits: { q: "اسباب‌بازی‌ها بر اساس هر سفارش قیمت‌گذاری می‌شوند. محصولات دیجیتال چطور؟", a: "کتاب داستان و فیلم انیمیشن از بسته‌های اعتباری (و اشتراک اختیاری) استفاده می‌کنند تا بتوانید بیشتر بسازید و کمتر بپردازید. هر کتاب داستان یا انیمیشن کوتاه یک اعتبار مصرف می‌کند. تا زمانی که اشتراکتان فعال است اعتبارها منقضی نمی‌شوند." },
        referral: { q: "آیا برنامه معرفی دارید؟", a: "بله. هر حساب در صفحه «حساب کاربری» یک لینک معرفی دارد. وقتی دوستی اولین سفارشش را ثبت کند، هر دو شما اعتبار می‌گیرید و با هر معرفی موفق در پله‌های برنامه بالاتر می‌روید." },
        birthday: { q: "باشگاه تولد چیست؟", a: "تولد فرزندتان را در صفحه «حساب کاربری» اضافه کنید و هر سال در روز تولدش یک تخفیف شخصی برایتان می‌فرستیم که برای اسباب‌بازی، کتاب و انیمیشن قابل استفاده است." },
        delivery: { q: "محصولات دیجیتال برایم ارسال می‌شوند؟", a: "کتاب‌های داستان و انیمیشن‌ها بلافاصله داخل حساب کاربری شما تحویل می‌شوند: پخش آنلاین، دانلود یا سفارش کتاب چاپی. فقط اسباب‌بازی‌های فیزیکی با پست ارسال می‌شوند." },
      },
    },
  },

  qualitySafetyDigital: {
    title: "محصولات دیجیتال — ایمنی و اعتماد",
    subtitle: "کتاب داستان و انیمیشن همان دقت اسباب‌بازی‌های فیزیکی ما را می‌گیرند.",
    items: {
      contentReview: { title: "بازبینی محتوای متناسب با سن", description: "هر متن کتاب داستان و درخواست انیمیشن از فیلترهای ایمنی خودکار ویژه محتوای کودکان عبور می‌کند." },
      parentApproval: { title: "والدین در کنترل می‌مانند", description: "شما شخصیت‌ها، داستان، تصویرسازی‌ها و صحنه‌ها را در هر مرحله بازبینی و تأیید می‌کنید. بدون تأیید شما هیچ‌چیز نهایی نمی‌شود." },
      noTraining: { title: "داده فرزند شما داده آموزشی نیست", description: "نقاشی، عکس، صدا و متن داستان آپلودی برای ساخت سفارش شما استفاده می‌شود — هرگز برای آموزش مدل‌های هوش مصنوعی خارجی." },
      moderation: { title: "تعدیل دوزبانه", description: "خط‌تولید بازبینی ما به دو زبان انگلیسی و فارسی کار می‌کند، پس استانداردهای ایمنی با زبان همراه هستند." },
    },
  },

  reviewsExtra: {
    soft: {
      headline: "محبوب خانواده‌ها در بریتانیا و فراتر از آن",
      subline: "چند داستان از خانواده‌هایی که با روبی چیزی ساخته‌اند.",
    },
    items: {
      laila: { name: "لیلا ر.", location: "منچستر، بریتانیا", title: "اسمش روی جلد. اشک روی صورت من.", review: "یک کتاب داستان شب‌خواب درباره دخترم و گربه‌اش ساختیم. هر شب درخواست می‌کند و به دو زبان برایمان «می‌خواند». ارزش هر پوندش را داشت.", date: "۲ هفته پیش", productLabel: "کتاب داستان" },
      omar: { name: "عمر ب.", location: "لندن، بریتانیا", title: "اولین انیمیشن، طرفدار لحظه‌ای", review: "نقاشی فضاپیمای پسرم را به فیلم کوتاه ۳۰ ثانیه‌ای تبدیل کردم. کل خانواده مدام تماشا کرد. هی می‌پرسد بعد کدام صحنه را عوض کنیم.", date: "۱ ماه پیش", productLabel: "انیمیشن" },
      nia: { name: "نیا پ.", location: "بریستول، بریتانیا", title: "کتاب داستان به فارسی و انگلیسی", review: "پدربزرگ و مادربزرگ ما فارسی صحبت می‌کنند و دخترمان در بریتانیا بزرگ می‌شود. شنیدن یک داستان به دو زبان چیزی بود که نمی‌دانستیم نیاز داریم.", date: "۳ هفته پیش", productLabel: "کتاب داستان" },
      karim: { name: "کریم س.", location: "ادینبرا، بریتانیا", title: "نسخه کارگردان در ۶ سالگی", review: "مرحله استوری‌بورد فوق‌العاده است — پسرم کنارم نشست و هر صحنه را مثل یک کارگردان کوچک تأیید کرد. فیلم نهایی بهتر از چیزی است که تصور می‌کردم.", date: "۵ روز پیش", productLabel: "انیمیشن" },
    },
  },

  termsExtra: {
    digital: {
      title: "۱۴. محصولات دیجیتال و اعتبارها",
      content: "کتاب‌های داستان و فیلم‌های انیمیشن تحویل‌های دیجیتالی هستند که بنا به درخواست ساخته می‌شوند. اعتبارها قابل انتقال نیستند. وقتی تولید نهایی را تأیید می‌کنید یک اعتبار مصرف می‌شود؛ اعتبار مصرف‌شده قابل بازگشت نیست. اگر تحویل نهایی از بررسی‌های کیفیت ما رد شود، بدون مصرف اعتبار اضافه دوباره اجرا می‌کنیم.",
    },
    subscriptions: {
      title: "۱۵. اشتراک‌ها",
      content: "هر دورهٔ صورت‌حساب وقتی زرین‌پال پرداخت را تأیید کند شروع می‌شود و اعتبار همان دوره فوراً واریز می‌شود. دورهٔ بعد فقط پس از پرداخت دوباره شروع می‌شود — امکان برداشت خودکار از کارت وجود ندارد. هر زمان می‌توانید لغو کنید؛ لغو در پایان دورهٔ پرداخت‌شده اعمال می‌شود. اعتبارهای دوره‌ای استفاده‌نشده پس از لغو منتقل نمی‌شوند.",
    },
    referral: {
      title: "۱۶. برنامه معرفی و باشگاه تولد",
      content: "اعتبار معرفی پس از تکمیل اولین سفارش پرداخت‌شده توسط مشتری معرفی‌شده اعطا می‌شود. تخفیف‌های تولد در هر سال تقویمی برای هر کودک یک‌بار صادر می‌شوند. در موارد سوءاستفاده — از جمله خودمعرفی، حساب‌های تکراری یا فعالیت متقلبانه — می‌توانیم پاداش‌ها را تعلیق یا لغو کنیم.",
    },
    acceptableUse: {
      title: "۱۷. استفاده مجاز",
      intro: "با استفاده از روبی می‌پذیرید محتوایی که موارد زیر است را آپلود یا درخواست نکنید:",
      items: [
        "جنسی، خشونت‌آمیز، نفرت‌انگیز یا به‌نحوی برای کودکان مضر",
        "نقض حق نشر، علامت تجاری یا حق تصویر دیگران",
        "طراحی‌شده برای جعل هویت فرد واقعی بدون رضایت او",
        "با هدف فریب، آزار یا آسیب به دیگران",
      ],
      note: "والدین و سرپرستان مسئول محتوای آپلودشده تحت حساب خود هستند. ما می‌توانیم هر سفارشی که این قوانین را نقض کند رد یا حذف کنیم.",
    },
    governingLaw: {
      title: "۱۸. قانون حاکم",
      content: "این شرایط تابع قوانین انگلستان و ولز است. دادگاه‌های انگلستان و ولز صلاحیت انحصاری بر هر اختلاف را دارند، با این استثنا که مصرف‌کنندگان در صورت الزام قانون محلی می‌توانند در دادگاه‌های کشور محل اقامت خود نیز اقامه دعوا کنند.",
    },
  },

  privacyExtra: {
    userContent: {
      title: "۴الف. نقاشی، عکس، صدا و داستان شما",
      intro: "هر چیزی که از طریق روبی می‌سازید یا آپلود می‌کنید را به‌عنوان محتوای شما در نظر می‌گیریم:",
      items: [
        "نقاشی و عکس‌های آپلودشده برای اسباب‌بازی، کتاب داستان یا انیمیشن",
        "متن داستان، نام شخصیت‌ها و جزئیات شخصی که ارائه می‌دهید",
        "ضبط‌های صوتی استفاده‌شده برای روایت یا صدای شخصیت",
        "تصویرسازی‌ها، مدل‌های سه‌بعدی، صدا و ویدئوی تولیدشده برای سفارش شما",
      ],
      note: "از این محتوا برای ساخت سفارش شما و بازبینی/تولید مجدد آن استفاده می‌کنیم. آن را نمی‌فروشیم و برای آموزش مدل‌های هوش مصنوعی خارجی استفاده نمی‌کنیم. اشتراک‌گذاری در گالری همیشه اختیاری است.",
    },
    billing: {
      title: "۱۱الف. داده اشتراک و پرداخت",
      content: "اشتراک‌ها و بسته‌های اعتباری از طریق زرین‌پال پرداخت می‌شوند. وضعیت اشتراک، طرح و تاریخ‌های صورت‌حساب را ذخیره می‌کنیم. هرگز شماره کامل کارت را ذخیره نمی‌کنیم.",
    },
    referralBirthday: {
      title: "۱۱ب. داده معرفی و باشگاه تولد",
      content: "اگر به برنامه معرفی بپیوندید، کد معرفی شما، حساب‌هایی که از طریق آن ثبت‌نام کرده‌اند و پاداش‌های کسب‌شده را ذخیره می‌کنیم. اگر فرزندتان را در باشگاه تولد ثبت کنید، نام کوچک و ماه/سال تولدش را برای ارسال تخفیف شخصی نگه می‌داریم. هر زمان می‌توانید از صفحه «حساب کاربری» انصراف دهید و این داده را حذف کنید.",
    },
    aiProcessing: {
      title: "۱۱ج. پردازش هوش مصنوعی",
      content: "برای تولید تصویرسازی، مدل سه‌بعدی، متن، صدا و انیمیشن، محتوایی که ارائه می‌دهید را به ارائه‌دهندگان تخصصی هوش مصنوعی تحت قراردادهایی می‌فرستیم که آموزش روی داده شما را ممنوع می‌کنند. درخواست، پاسخ و زمان‌بندی را برای اشکال‌زدایی و ایمنی لاگ می‌کنیم و این لاگ‌ها را به‌صورت چرخشی ۹۰ روزه حذف می‌کنیم.",
    },
  },

  contactExtra: {
    quickLinks: {
      story: "ساخت کتاب داستان شخصی‌سازی‌شده",
      animation: "ساخت فیلم انیمیشن کوتاه",
    },
  },

  howItWorksExtra: {
    tabs: {
      toy: "اسباب‌بازی",
      storybook: "کتاب داستان",
      animation: "انیمیشن",
    },
    storybook: {
      title: "کتاب داستان شخصی‌سازی‌شده چطور ساخته می‌شود",
      steps: {
        upload: { title: "آپلود و معرفی فرزندتان", description: "یک نقاشی یا عکس، نام، سن و چند جزئیات که می‌خواهید داستان آن‌ها را جشن بگیرد اضافه کنید." },
        story: { title: "هوش مصنوعی می‌نویسد و تصویرسازی می‌کند", description: "متن، شخصیت‌ها و تصویرسازی صفحه‌به‌صفحه در سبک انتخابی شما تولید می‌کنیم. هر صفحه را می‌بینید." },
        narration: { title: "روایت اختیاری", description: "صدای انگلیسی یا فارسی اضافه کنید (یا صدای خودتان را ضبط کنید) تا کتاب در شب‌خواب خودش خوانده شود." },
        deliver: { title: "آنلاین بخوانید یا چاپی سفارش دهید", description: "کتاب را در نمایشگر فلیپ‌بوک ما پخش کنید، PDF را دانلود کنید یا نسخه چاپی سفارش دهید." },
      },
    },
    animation: {
      title: "فیلم انیمیشن کوتاه چطور ساخته می‌شود",
      steps: {
        upload: { title: "یک نقاشی یا عکس آپلود کنید", description: "فقط یک تصویر کافی است — یک شخصیت، یک مکان یا عکسی از فرزندتان." },
        story: { title: "داستان و استوری‌بورد را تأیید کنید", description: "داستانی و استوری‌بورد صحنه‌به‌صحنه پیشنهاد می‌دهیم. قبل از رندر هر چه می‌خواهید ویرایش، عوض یا دوباره اجرا کنید." },
        direct: { title: "صحنه‌ها را کارگردانی کنید", description: "پشت‌صحنه برای هر صحنه یادداشت کارگردانی (دوربین، نور، فضا) تولید می‌کنیم تا فیلم نهایی هدفمند باشد، نه تصادفی." },
        watch: { title: "تماشا و اشتراک‌گذاری", description: "فیلم نهایی ظرف چند دقیقه در حساب شما قرار می‌گیرد. MP4 را دانلود کنید، لینک به اشتراک بگذارید یا با یک اسباب‌بازی هماهنگ سفارش دهید." },
      },
    },
  },
  heroNav: {
    toy: 'اسباب‌بازی',
    story: 'قصه',
    animation: 'انیمیشن',
    game: 'بازی',
    gallery: 'گالری',
    howItWorks: 'چطور کار می‌کند',
    pricing: 'قیمت',
    reviews: 'نظرات',
    products: 'محصولات روبی',
    customServices: 'سرویس‌های سفارشی',
  },

  magicPreview: {
    title: "پیش‌نمایش جادو",
    subtitle: "برای هر شخصیت یک کاراکتر استایل‌شده می‌بینید — تا در صفحات یکسان بماند.",
    subtitleAnimation: "برای هر شخصیت یک کاراکتر استایل‌شده می‌بینید — تا در صحنه‌ها یکسان بماند.",
    empty: "هنوز شخصیتی نیست. برای افزودن به آپلود برگردید.",
    analyseSource: "منبع تحلیل",
    originalAlt: "اصلی",
    referenceCharacter: "کاراکتر مرجع",
    generating: "در حال ساخت کاراکتر…",
    notGenerated: "هنوز ساخته نشده",
    editLabel: "تغییراتی که می‌خواهید را بنویسید",
    editPlaceholder: "مثلاً موها فرتر شود، شال قرمز اضافه شود",
    editNeedDetail: "لطفاً جزئیات بیشتری بنویسید",
    editNeedDetailDesc: "تغییرات را شرح دهید (حداقل ۱۰ کاراکتر).",
    submitEdit: "ارسال ویرایش",
    generate: "ساخت",
    regenerate: "ساخت دوباره",
    edit: "ویرایش",
    nameRequired: "نام لازم است",
    nameRequiredDesc: "اول برای این شخصیت یک نام بگذارید.",
    generateUnavailable: "ساخت در دسترس نیست",
    generateUnavailableDesc: "صفحه را دوباره بارگذاری کنید و دوباره تلاش کنید.",
  },

  viewer3d: {
    loaded: "مدل سه‌بعدی {name} بارگذاری شد",
    loadedFallback: "اسباب‌بازی",
    loadError: "خطا در بارگذاری مدل",
    sizeChanged: "اندازه: {value}",
    materialChanged: "جنس: {value}",
    colorChanged: "رنگ: {value}",
    cameraReset: "دوربین بازنشانی شد",
    interactive: "پیش‌نمایش سه‌بعدی تعاملی",
    ofName: "از {name}",
    size: "اندازه: {value}",
    material: "جنس: {value}",
    instructions: "از کلیدهای جهت‌دار یا ماوس برای چرخاندن مدل استفاده کنید. از اسکرول ماوس یا پینچ برای زوم استفاده کنید.",
    cameraAngles: "زاویه دوربین",
    resetCamera: "بازنشانی دوربین",
    front: "جلو",
    back: "پشت",
    left: "چپ",
    right: "راست",
    top: "بالا",
    loadingViewer: "بارگذاری مدل سه‌بعدی...",
    fullColor: "رنگ کامل",
    sizeComparison: "مقایسه اندازه",
    hideSizeRef: "پنهان کردن مرجع اندازه",
    showSizeRef: "نمایش مرجع اندازه",
    loadingModel: "در حال بارگذاری مدل سه‌بعدی...",
    sizeSmall: "۸ سانتی‌متر",
    sizeMedium: "۱۲ سانتی‌متر",
    sizeLarge: "۱۸ سانتی‌متر",
    sizeVeryLarge: "۲۴ سانتی‌متر",
    materialPla: "PLA استاندارد",
    materialPetg: "PETG مقاوم",
    materialTpu: "TPU انعطاف‌پذیر",
    materialResin: "رزین با جزئیات بالا",
  },

  shareCard: {
    shareFailed: "ساخت لینک اشتراک ناموفق بود",
    shareText: "ببینید چه اسباب‌بازی‌ای با RUBBY ساختم! 🎨🧸 {name}",
    imageDownloaded: "تصویر دانلود شد!",
    downloadFailed: "خطا در دانلود",
    checkOut: "ببین چی ساختم با RUBBY!",
    linkNotReady: "لینک اشتراک هنوز آماده نیست",
    linkCopied: "لینک کپی شد!",
    copyFailed: "خطا در کپی",
    title: "ساخته خود را به اشتراک بگذارید",
    originalDrawing: "نقاشی اصلی",
    toy3d: "اسباب‌بازی سه‌بعدی",
    madeWith: "ساخته شده با RUBBY — نقاشی کودک، اسباب‌بازی واقعی",
    saving: "در حال دانلود...",
    downloadImage: "دانلود تصویر",
    copied: "کپی شد!",
    copyLink: "کپی لینک",
    twitter: "اشتراک در توییتر",
    facebook: "اشتراک در فیسبوک",
    whatsapp: "اشتراک در واتساپ",
    email: "اشتراک با ایمیل",
  },

  resumeProject: {
    title: "ادامه پروژه قبلی؟",
    unfinished: "شما {timeAgo} یک پروژه ناتمام دارید.",
    discount: "تخفیف ۱۵٪ برای تکمیل سفارش!",
    code: "کد:",
    continue: "ادامه از جایی که بودم",
    startFresh: "شروع جدید",
    minutesAgo: "{n} دقیقه پیش",
    hoursAgo: "{n} ساعت پیش",
    daysAgo: "{n} روز پیش",
    previewAlt: "پیش‌نمایش پروژه",
  },

  priceBreakdown: {
    digitalModel: "مدل سه‌بعدی دیجیتال (.glb)",
    baseToy: "قیمت پایه اسباب‌بازی",
    sizeUpgrade: "ارتقاء اندازه",
    materialUpgrade: "ارتقاء متریال",
    fullColor: "رنگ کامل",
    addModel: "افزودن مدل سه‌بعدی (.glb)",
    title: "جزئیات قیمت",
    subtotal: "جمع فرعی",
    shipping: "ارسال",
    total: "مجموع",
    instantDownload: "دانلود فوری پس از پرداخت",
    moneyBack: "ضمانت بازگشت ۳۰ روزه",
    toggle: "نمایش جزئیات قیمت",
    estimatedTotal: "جمع کل",
    basePrice: "قیمت پایه",
    sizeUpgradeShort: "اندازه",
    materialUpgradeShort: "متریال",
    colorUpgrade: "رنگ",
  },

  paymentConfirm: {
    title: "تایید سفارش",
    total: "مبلغ کل:",
    guaranteeTitle: "ضمانت رضایت ۱۰۰٪",
    guaranteeBody: "اگر از اسباب‌بازی خود راضی نیستید، ظرف ۳۰ روز مبلغ را بازمی‌گردانیم. بدون سوال.",
    paySecurely: "پرداخت امن",
  },

  gamePage: {
    title: "بازی",
    seoTitle: "بازی | روبی",
    seoDescription: "بازی با نقاشی‌های فرزندتان. به زودی.",
    badge: "به زودی",
    body: "چیزی بازیگوش در راه است. منتظر بمانید!",
  },

  photoToGame: {
    title: "عکس به بازی",
    subtitle: "به زودی — عکس محبوب‌تان را به یک مینی‌بازی تبدیل کنید.",
    body: "چیزی بازیگوش می‌سازیم. کمی بعد سر بزنید، یا همین حالا سازنده‌های دیگر را ببینید.",
    backHome: "بازگشت به خانه",
  },

  kitchen: {
    headline: "روبی بهترین راه برای تبدیل تخیل به محصول واقعی با فناوری جدید و پردازش لحظه‌ای است",
  },

  sharedCreation: {
    incomplete: "این لینک اشتراک ناقص است",
    notFound: "این ساخته پیدا نشد",
    createYours: "بسازید",
    createYoursAlt: "ساخت ساخته خودت",
    fallbackName: "یک ساخته با ریکو",
    seoDescription: "ببینید چه چیزی با ریکو ساخته شد: {name}",
    madeWith: "ساخته شده با ریکو",
    drawing: "نقاشی",
    toy: "اسباب‌بازی",
    noAssets: "تصویری موجود نیست",
  },

  createFab: {
    start: "شروع ساخت!",
    startToy: "شروع ساخت اسباب‌بازی",
  },

  nav: {
    bottom: "منوی پایین",
    stepOf: "مرحله {current} از {total}",
    stepOfLabel: "مرحله {current} از {total}: {label}",
  },

  reorder: {
    preparing: "در حال آماده‌سازی سفارش مجدد...",
    failed: "خطا در سفارش مجدد",
  },

  birthdayClub: {
    title: "باشگاه تولد",
  },

  referral: {
    title: "معرفی و کسب درآمد",
  },

  testimonialsUi: {
    fromReviews: "از {n} نظر",
    loadMore: "بارگذاری بیشتر",
  },

  confirmedTray: {
    removeCharacter: "حذف کاراکتر",
  },

  specsUi: {
    perForever: "/ برای همیشه",
    perMonth: "/ ماهانه",
    chooseSize: "انتخاب اندازه",
    chooseMaterial: "انتخاب جنس",
    chooseColor: "انتخاب رنگ",
    smallLabel: "کوچک (۱۰ سانتی‌متر)",
    smallDesc: "اندازه رومیزی",
    mediumLabel: "متوسط (۱۸ سانتی‌متر)",
    mediumDesc: "عالی برای بازی و نمایش",
    largeLabel: "بزرگ (۲۵ سانتی‌متر)",
    largeDesc: "اندازه بغل کردنی",
    veryLargeLabel: "خیلی بزرگ (۳۵ سانتی‌متر)",
    veryLargeDesc: "اندازه بزرگ ویژه",
    plaLabel: "PLA استاندارد",
    plaDesc: "جزئیات عالی، سازگار با محیط زیست",
    petgLabel: "PETG مقاوم",
    petgDesc: "بسیار مقاوم برای بازی شدید",
    tpuLabel: "TPU انعطاف‌پذیر",
    tpuDesc: "نرم و انعطاف‌پذیر، مناسب کودکان",
    resinLabel: "رزین با جزئیات بالا",
    resinDesc: "کیفیت نمایشگاهی",
    singleLabel: "تک رنگ",
    singleDesc: "ظاهر تمیز و کلاسیک",
    fullLabel: "تمام رنگ",
    fullDesc: "رنگ‌های شاد و واقعی",
  },

  checkoutTrust: {
    moneyBack: "بازگشت ۳۰ روزه",
    ssl: "پرداخت امن",
    noHiddenFees: "بدون هزینه پنهان",
    trackedShipping: "ارسال قابل پیگیری",
  },

  storyReader: {
    femaleVoices: "صداهای زن",
    maleVoices: "صداهای مرد",
    recommendedShort: "پیشنهادی",
    character: {
      Sulafat: "گرم",
      Vindemiatrix: "ملایم",
      Aoede: "شاد",
      Leda: "جوان",
      Despina: "نرم",
      Achernar: "آرام",
      Achird: "دوستانه",
      Puck: "پرانرژی",
      Charon: "آگاه‌کننده",
      Sadachbia: "زنده",
      Enceladus: "نفس‌دار",
    },
    bestFor: {
      Sulafat: "قصه‌های شب، همه سنین",
      Vindemiatrix: "داستان خردسال، روایت آرام",
      Aoede: "ماجراجویی سبک، داستان‌های شاد",
      Leda: "صدای جوان، قابل‌همذات‌پنداری برای کودکان",
      Despina: "قصه‌های پریان شیک",
      Achernar: "روایت آرام و لالایی‌مانند",
      Achird: "راوی گرم و صمیمی",
      Puck: "انرژی، کمدی، داستان اکشن",
      Charon: "قصه‌گوی آرام، آموزشی",
      Sadachbia: "داستان‌های شخصیت‌محور و پرجنب‌وجوش",
      Enceladus: "راوی مرد نرم و ملایم",
    },
  },

  seo: {
    defaultTitle: "روبی — اسباب‌بازی، کتاب داستان و انیمیشن از هنر کودکان",
    defaultDescription: "نقاشی یا عکس کودکتان را به اسباب‌بازی چاپ سه‌بعدی، کتاب داستان شخصی یا فیلم کوتاه انیمیشن تبدیل کنید. مستقر در بریتانیا، ایمن برای کودک، ارسال سریع.",
    titleSuffix: "{title} | RUBBY",
    pricingTitle: "قیمت‌ها",
    pricingDesc: "قیمت اسباب‌بازی‌های چاپ سه‌بعدی سفارشی را ببینید. پکیج، اندازه، جنس و طرح رنگ را انتخاب کنید.",
    trackOrderTitle: "پیگیری سفارش",
    accountTitle: "حساب من",
    faqTitle: "سوالات متداول — اسباب‌بازی، کتاب داستان و انیمیشن",
    faqDesc: "پاسخ‌هایی درباره اسباب‌بازی‌های چاپ سه‌بعدی روبی، کتاب‌های داستان شخصی، فیلم‌های انیمیشن، اعتبار، ارسال و ایمنی.",
    reviewsTitle: "نظرات — اسباب‌بازی، کتاب داستان و انیمیشن روبی",
    reviewsDesc: "داستان واقعی خانواده‌هایی که با روبی اسباب‌بازی چاپ سه‌بعدی، کتاب داستان شخصی و فیلم کوتاه ساخته‌اند.",
    storybookTitle: "کتاب داستان خود را بسازید",
    signInTitle: "ورود",
    privacyTitle: "حریم خصوصی — روبی",
    privacyDesc: "روبی چطور داده‌های خانواده شما را در اسباب‌بازی، کتاب داستان و انیمیشن محافظت می‌کند. مطابق UK-GDPR و EU-GDPR.",
    galleryTitle: "گالری",
    galleryDesc: "گالری اسباب‌بازی‌های چاپ سه‌بعدی ساخته‌شده از نقاشی واقعی کودکان را ببینید.",
    animationTitle: "انیمیشن خود را بسازید",
    toyTitle: "اسباب‌بازی سفارشی خود را بسازید",
    contactTitle: "تماس با روبی",
    contactDesc: "با تیم روبی درباره اسباب‌بازی، کتاب داستان، انیمیشن یا سفارشتان در تماس باشید. مستقر در بریتانیا، ظرف ۲۴ ساعت پاسخ می‌دهیم.",
    homeTitle: "روبی — خانه",
    qualityTitle: "کیفیت و ایمنی — اسباب‌بازی، کتاب داستان و انیمیشن",
    qualityDesc: "مواد ایمن برای کودک و فرآیند کیفیت روبی، به‌علاوه استانداردهای ایمنی محتوا برای کتاب داستان و انیمیشن.",
    howItWorksTitle: "روبی چطور کار می‌کند — اسباب‌بازی، کتاب داستان و انیمیشن",
    howItWorksDesc: "ببینید روبی چطور یک نقاشی یا عکس را به اسباب‌بازی چاپ سه‌بعدی، کتاب داستان شخصی یا فیلم کوتاه انیمیشن تبدیل می‌کند.",
    termsTitle: "شرایط استفاده — روبی",
    termsDesc: "شرایط روبی برای اسباب‌بازی چاپ سه‌بعدی سفارشی، کتاب داستان شخصی، فیلم انیمیشن، اعتبار و اشتراک.",
    landingTitle: "نقاشی کودکان را به اسباب‌بازی سه‌بعدی واقعی تبدیل کنید",
    landingDesc: "اثر هنری کودکتان را به اسباب‌بازی چاپ سه‌بعدی سفارشی تبدیل کنید. طراحی با هوش مصنوعی، مواد ایمن برای کودک، ارسال در ۱۴ روز.",
    aboutTitle: "درباره روبی — اسباب‌بازی، کتاب داستان و انیمیشن از هنر کودکان",
    aboutDesc: "تیم پشت روبی را بشناسید. نقاشی و عکس کودکان را به اسباب‌بازی چاپ سه‌بعدی، کتاب داستان شخصی و فیلم کوتاه انیمیشن تبدیل می‌کنیم.",
  },

  errorBoundary: {
    sadFace: "چهره ناراحت",
    title: "مشکلی پیش آمد",
    body: "خطای غیرمنتظره‌ای رخ داد. می‌توانید صفحه را تازه کنید یا به خانه برگردید.",
    details: "جزئیات خطا",
    tryAgain: "تلاش مجدد",
    goHome: "رفتن به خانه",
  },

  accountShipping: {
    comingSoon: "به‌زودی",
    comingSoonDesc: "ذخیره آدرس‌های پیش‌فرض حمل‌ونقل هنوز از طریق API در دسترس نیست.",
  },

  styleQuiz: {
    styles: {
      pixar3d: "پیکسار سه‌بعدی",
      realistic: "واقع‌گرایانه",
      chibi: "چیبی",
      brick: "فیگور آجری",
      vinyl: "وینیل طراحی",
      bighead_vinyl: "وینیل کله‌بزرگ",
      blindbox: "جعبه‌رمز وینیل",
      claymation: "خمیری",
      bobblehead: "باب‌بل‌هد",
    },
    sizes: {
      small: "کوچک",
      medium: "متوسط",
      large: "بزرگ",
      very_large: "خیلی بزرگ",
    },
    materials: {
      standard_pla: "PLA استاندارد",
      tough_petg: "PETG مقاوم",
      flexible_tpu: "TPU انعطاف‌پذیر",
      high_detail_resin: "رزین با جزئیات بالا",
    },
    colors: {
      single_color: "تک‌رنگ",
      full_color: "تمام‌رنگی",
    },
    qChildAge: "سن کودک چقدر است؟",
    qColors: "کودک چه رنگ‌هایی را دوست دارد؟",
    qPersonality: "شخصیت کودک چگونه است؟",
    age02: "۰-۲ سال",
    age35: "۳-۵ سال",
    age68: "۶-۸ سال",
    age912: "۹-۱۲ سال",
    age13: "۱۳+ سال",
    pastels: "رنگ‌های ملایم",
    vibrant: "شاد و پررنگ",
    neutral: "رنگ‌های طبیعی",
    rainbow: "همه رنگ‌ها!",
    adventurous: "ماجراجو",
    sweet: "مهربان و دوست‌داشتنی",
    playful: "بازیگوش و پرانرژی",
    artistic: "خلاق و هنری",
    resultTitle: "این پیشنهاد ماست",
    quizTitle: "پیشنهاد هوشمند",
    basedOnAnswers: "بر اساس پاسخ‌های شما",
    questionOf: "سوال {current} از {total}",
    skip: "رد شدن، خودم انتخاب می‌کنم",
    apply: "اعمال پیشنهادات",
    retake: "پاسخ مجدد به سوالات",
    colorPlan: "طرح رنگ",
    reasonTpuInfant: "TPU انعطاف‌پذیر نرم و ایمن برای دندان درآوردن است.",
    reasonPlaPlay: "PLA استاندارد مقاوم و ایمن برای بازی فعال است.",
    reasonPlaDetail: "PLA جزئیات خوبی برای این گروه سنی دارد.",
    reasonPetgRough: "PETG برای بچه‌های بزرگ‌تر که بازی خشن دارند مقاوم‌تر است.",
    reasonSizeLargeHands: "اسباب‌بازی بزرگ‌تر برای دست‌های کوچک امن‌تر و راحت‌تر است.",
    reasonSizeMediumCuddle: "اندازه متوسط برای بغل کردن در این سن عالی است.",
    reasonSizeSmallShelf: "اندازه جمع‌وجور که روی قفسه یا در کوله‌پشتی جا می‌شود.",
    reasonStyleChibiAdventure: "سبک چیبی با روحیه ماجراجویشان جور است!",
    reasonStylePixarAdventure: "سبک پیکسار سه‌بعدی ماجراجویی‌شان را زنده می‌کند.",
    reasonStylePixarSweet: "سبک نرم پیکسار برای شخصیت مهربان عالی است.",
    reasonStyleBrickPlayful: "سبک فیگور آجری شاد و بازیگوش است — درست مثل خودشان!",
    reasonStyleRealisticArtistic: "سبک واقع‌گرایانه جزئیات هنری‌شان را نشان می‌دهد.",
    reasonStyleVinylArtistic: "سبک وینیل طراحی حس هنری به ساخته‌شان می‌دهد.",
    reasonColorFull: "رنگ کامل پالت شادی که دوست دارند را نشان می‌دهد.",
    reasonColorSingle: "تک‌رنگ ظاهر تمیز و شیکی می‌سازد.",
  },
};



